
import React,{useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import {Alert, Col,Row,Table,Card,Button, Modal, Form, InputGroup, FormCheck, Badge, Spinner} from 'react-bootstrap'

import { Link, useLocation, useNavigate } from 'react-router-dom'
import "../../../assets/custom/css/subjects.scss"

import QuestionsTable from '../components/QuestionsTable'
import QuizScreen from '../components/QuizScreen'; // Importa il componente del quiz
import { getAutomaticKeywordHint, getSavedKeywordHint, isQuestionKeywordHintDisabled } from '../components/questionKeywordHighlight';
//import Loader from '../../../components/Loader'; 
import { useLoader } from '../../../components/loader/LoaderContext'; // Importa il contesto del Loader
//import { useLoader } from './components/loader/LoaderContext'; // Importa il contesto del Loader

import axios from 'axios';

import DataTable from 'datatables.net-bs5';

//flatpicker
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useLanguage } from '../../../i18n/LanguageContext';
import { useAuth } from '../../../components/auth/AuthProvider';
import apiUrl from '../../../config/api';
import {
    filterQuestionsByView,
    getQuestionFilterAvailability,
    getQuestionsByType,
    orderQuestionsForQuiz as orderQuestionsByProgress,
    selectQuestionsForQuiz,
} from '../../../utils/quizQuestionSelection';

const data1 = [
    { id: 1, question: 'What is the capital of France?', answers: 'Berlin, Madrid, Paris, Rome', correct: 'Paris' },
    { id: 2, question: 'What is the capital of Italy?', answers: 'Milan, Rome, Venice, Naples', correct: 'Rome' },
    { id: 3, question: 'What is the capital of Italy?', answers: 'Milan, Rome, Venice, Naples', correct: 'Rome' },
  ];

const isAuthError = (error) => error.response?.status === 401;
const readStoredJson = (key, fallback = {}) => {
    try {
        const storedValue = localStorage.getItem(key);
        return storedValue ? JSON.parse(storedValue) : fallback;
    } catch (error) {
        return fallback;
    }
};

const setStoredValue = (key, value) => {
    try {
        localStorage.setItem(key, value);
    } catch (error) {
        console.warn('Unable to save local preference:', error);
    }
};

const clearActiveButtonFocus = (event) => {
    event?.currentTarget?.blur?.();
    window.setTimeout(() => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }, 0);
};

const wrong=    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 20L20 4M20 20L4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>

const right=    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path  d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>

const add =     <svg width="200" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="2 2 20 20">                     
                    <path opacity="0.4" d="M16.6667 2H7.33333C3.92889 2 2 3.92889 2 7.33333V16.6667C2 20.0622 3.92 22 7.33333 22H16.6667C20.0711 22 22 20.0622 22 16.6667V7.33333C22 3.92889 20.0711 2 16.6667 2Z" fill="currentColor"></path><path d="M15.3205 12.7083H12.7495V15.257C12.7495 15.6673 12.4139 16 12 16C11.5861 16 11.2505 15.6673 11.2505 15.257V12.7083H8.67955C8.29342 12.6687 8 12.3461 8 11.9613C8 11.5765 8.29342 11.2539 8.67955 11.2143H11.2424V8.67365C11.2824 8.29088 11.6078 8 11.996 8C12.3842 8 12.7095 8.29088 12.7495 8.67365V11.2143H15.3205C15.7066 11.2539 16 11.5765 16 11.9613C16 12.3461 15.7066 12.6687 15.3205 12.7083Z" fill="currentColor"></path>                 
                </svg>
        
const quiz =    <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M22 12.0048C22 17.5137 17.5116 22 12 22C6.48842 22 2 17.5137 2 12.0048C2 6.48625 6.48842 2 12 2C17.5116 2 22 6.48625 22 12.0048Z" fill="currentColor"></path><path d="M16 12.0049C16 12.2576 15.9205 12.5113 15.7614 12.7145C15.7315 12.7543 15.5923 12.9186 15.483 13.0255L15.4233 13.0838C14.5881 13.9694 12.5099 15.3011 11.456 15.7278C11.456 15.7375 10.8295 15.9913 10.5312 16H10.4915C10.0341 16 9.60653 15.7482 9.38778 15.34C9.26847 15.1154 9.15909 14.4642 9.14915 14.4554C9.05966 13.8712 9 12.9769 9 11.9951C9 10.9657 9.05966 10.0316 9.16903 9.45808C9.16903 9.44836 9.27841 8.92345 9.34801 8.74848C9.45739 8.49672 9.65625 8.2819 9.90483 8.14581C10.1037 8.04957 10.3125 8 10.5312 8C10.7599 8.01069 11.1875 8.15553 11.3565 8.22357C12.4702 8.65128 14.598 10.051 15.4134 10.9064C15.5526 11.0425 15.7017 11.2087 15.7415 11.2467C15.9105 11.4605 16 11.723 16 12.0049Z" fill="currentColor"></path>
                </svg>

const quest =   <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M18.8088 9.021C18.3573 9.021 17.7592 9.011 17.0146 9.011C15.1987 9.011 13.7055 7.508 13.7055 5.675V2.459C13.7055 2.206 13.5036 2 13.253 2H7.96363C5.49517 2 3.5 4.026 3.5 6.509V17.284C3.5 19.889 5.59022 22 8.16958 22H16.0463C18.5058 22 20.5 19.987 20.5 17.502V9.471C20.5 9.217 20.299 9.012 20.0475 9.013C19.6247 9.016 19.1177 9.021 18.8088 9.021Z" fill="currentColor"></path><path opacity="0.4" d="M16.0842 2.56737C15.7852 2.25637 15.2632 2.47037 15.2632 2.90137V5.53837C15.2632 6.64437 16.1742 7.55437 17.2802 7.55437C17.9772 7.56237 18.9452 7.56437 19.7672 7.56237C20.1882 7.56137 20.4022 7.05837 20.1102 6.75437C19.0552 5.65737 17.1662 3.69137 16.0842 2.56737Z" fill="currentColor"></path><path fillRule="evenodd" clipRule="evenodd" d="M8.97398 11.3877H12.359C12.77 11.3877 13.104 11.0547 13.104 10.6437C13.104 10.2327 12.77 9.89868 12.359 9.89868H8.97398C8.56298 9.89868 8.22998 10.2327 8.22998 10.6437C8.22998 11.0547 8.56298 11.3877 8.97398 11.3877ZM8.97408 16.3819H14.4181C14.8291 16.3819 15.1631 16.0489 15.1631 15.6379C15.1631 15.2269 14.8291 14.8929 14.4181 14.8929H8.97408C8.56308 14.8929 8.23008 15.2269 8.23008 15.6379C8.23008 16.0489 8.56308 16.3819 8.97408 16.3819Z" fill="currentColor"></path>
                </svg>

const edit =    <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z" fill="currentColor"></path><path d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z" fill="currentColor"></path><path opacity="0.4" d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z" fill="currentColor"></path>
                </svg>

const del =     <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z" fill="currentColor"></path><path d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z" fill="currentColor"></path>
                </svg>

const add2 =     <svg width="32" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">                     
                    <path opacity="0.4" d="M16.6667 2H7.33333C3.92889 2 2 3.92889 2 7.33333V16.6667C2 20.0622 3.92 22 7.33333 22H16.6667C20.0711 22 22 20.0622 22 16.6667V7.33333C22 3.92889 20.0711 2 16.6667 2Z" fill="currentColor"></path><path d="M15.3205 12.7083H12.7495V15.257C12.7495 15.6673 12.4139 16 12 16C11.5861 16 11.2505 15.6673 11.2505 15.257V12.7083H8.67955C8.29342 12.6687 8 12.3461 8 11.9613C8 11.5765 8.29342 11.2539 8.67955 11.2143H11.2424V8.67365C11.2824 8.29088 11.6078 8 11.996 8C12.3842 8 12.7095 8.29088 12.7495 8.67365V11.2143H15.3205C15.7066 11.2539 16 11.5765 16 11.9613C16 12.3461 15.7066 12.6687 15.3205 12.7083Z" fill="currentColor"></path>                 
                </svg>

const uploadPdf = <svg width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M16.5 2H7.5C5.57 2 4 3.57 4 5.5V18.5C4 20.43 5.57 22 7.5 22H16.5C18.43 22 20 20.43 20 18.5V5.5C20 3.57 18.43 2 16.5 2Z" fill="currentColor"></path>
                    <path d="M12 15.75C11.59 15.75 11.25 15.41 11.25 15V9.81L9.53 11.53C9.24 11.82 8.76 11.82 8.47 11.53C8.18 11.24 8.18 10.76 8.47 10.47L11.47 7.47C11.76 7.18 12.24 7.18 12.53 7.47L15.53 10.47C15.82 10.76 15.82 11.24 15.53 11.53C15.24 11.82 14.76 11.82 14.47 11.53L12.75 9.81V15C12.75 15.41 12.41 15.75 12 15.75Z" fill="currentColor"></path>
                    <path d="M16 18.75H8C7.59 18.75 7.25 18.41 7.25 18C7.25 17.59 7.59 17.25 8 17.25H16C16.41 17.25 16.75 17.59 16.75 18C16.75 18.41 16.41 18.75 16 18.75Z" fill="currentColor"></path>
                </svg>

const isClosedQuestionMissingCorrectAnswer = (question) => (
    question?.questionType === 'closed'
    && Array.isArray(question.answers)
    && !question.answers.some((answer) => answer.isCorrect)
);

const isOpenQuestionMissingAnswer = (question) => (
    question?.questionType === 'open'
    && (
        !Array.isArray(question.answers)
        || !question.answers.some((answer) => String(answer?.text || '').trim())
    )
);

const ImportPreloader = ({ show, title, message, hint }) => {
    if (!show || typeof document === 'undefined') {
        return null;
    }

    return createPortal(
        <div className="import-preloader-overlay" role="alert" aria-live="assertive" aria-modal="true">
            <div className="import-preloader-card">
                <Spinner animation="border" variant="primary" className="import-preloader-spinner mb-3" />
                <h5 className="mb-2">{title}</h5>
                <p className="mb-2">{message}</p>
                <small className="text-muted d-block">{hint}</small>
            </div>
        </div>,
        document.body
    );
};

const add3 =     <svg width="32" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">                     
                    <path opacity="0.4" d="M16.6667 2H7.33333C3.92889 2 2 3.92889 2 7.33333V16.6667C2 20.0622 3.92 22 7.33333 22H16.6667C20.0711 22 22 20.0622 22 16.6667V7.33333C22 3.92889 20.0711 2 16.6667 2Z" fill="currentColor"></path><path d="M15.3205 12.7083H12.7495V15.257C12.7495 15.6673 12.4139 16 12 16C11.5861 16 11.2505 15.6673 11.2505 15.257V12.7083H8.67955C8.29342 12.6687 8 12.3461 8 11.9613C8 11.5765 8.29342 11.2539 8.67955 11.2143H11.2424V8.67365C11.2824 8.29088 11.6078 8 11.996 8C12.3842 8 12.7095 8.29088 12.7495 8.67365V11.2143H15.3205C15.7066 11.2539 16 11.5765 16 11.9613C16 12.3461 15.7066 12.6687 15.3205 12.7083Z" fill="currentColor"></path>                 
                </svg>

const del3 =     <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z" fill="currentColor"></path><path d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z" fill="currentColor"></path>
                </svg>

const Subjects = () => {
    const { isAuthLoading, userDetails } = useAuth();
    const { language, t } = useLanguage();
    const location = useLocation();
    const navigate = useNavigate();
    const text = t.subjectsPage;
    const canImportQuestionBankPdf = language === 'it';
    const subjectQuizSettingsStorageKey = `quizify-subject-quiz-settings-${userDetails?.email || 'local'}`;

    const [toggleState, setToggleState] = useState(true);

    // Modal Quiz
    const [showModalQuiz, setShowModalQuiz] = useState(false);
    const handleCloseQuiz = () => {
        setSelectedSubject(null);
        setSubjectName('');
        setQuestions("");
        setShowModalQuiz(false);
    };

    const timerRef = useRef(null); // Crea un ref per il Flatpickr
    // QuizScreen
    const [showQuizScreen, setShowQuizScreen] = useState(false); // Stato per mostrare il QuizScreen
    const [quizParams, setQuizParams] = useState({});
    const [quizSettingsBySubjectId, setQuizSettingsBySubjectId] = useState({});
    const [loadedSubjectQuizSettingsKey, setLoadedSubjectQuizSettingsKey] = useState('');

    useEffect(() => {
        if (isAuthLoading) {
            return;
        }

        const storedSettings = readStoredJson(subjectQuizSettingsStorageKey);
        const safeStoredSettings = storedSettings && typeof storedSettings === 'object' && !Array.isArray(storedSettings)
            ? storedSettings
            : {};

        setQuizSettingsBySubjectId(safeStoredSettings);
        setLoadedSubjectQuizSettingsKey(subjectQuizSettingsStorageKey);
    }, [isAuthLoading, subjectQuizSettingsStorageKey]);

    useEffect(() => {
        if (isAuthLoading || loadedSubjectQuizSettingsKey !== subjectQuizSettingsStorageKey) {
            return;
        }

        setStoredValue(subjectQuizSettingsStorageKey, JSON.stringify(quizSettingsBySubjectId));
    }, [
        isAuthLoading,
        loadedSubjectQuizSettingsKey,
        quizSettingsBySubjectId,
        subjectQuizSettingsStorageKey,
    ]);

    const handleShowQuiz = () => {
        setShowModalQuiz(true)
    };

    // Modal Add
    const [showAddSubject, setShowAddSubject] = useState(false);
    const handleCloseAddSubject = () => {
        if (isImportingAllPdf) {
            return;
        }

        setShowAddSubject(false);
        setIsAddSubjectImportMode(false);
        setImportAllPdfType('ecampus');
        setImportAllPdfFile(null);
        setImportAllReport(null);
        setIsImportingAllPdf(false);
    };
    const handleShowAddSubject = () => {
        setIsAddSubjectImportMode(false);
        setImportAllPdfType('ecampus');
        setImportAllPdfFile(null);
        setImportAllReport(null);
        setIsImportingAllPdf(false);
        setShowAddSubject(true);
    };

    // Modal Del
    const [showModalDel, setShowModalDel] = useState(false);
    const handleCloseDel = () => setShowModalDel(false);
    const handleShowDel = () => setShowModalDel(true);

    // Modal Edit
    const [showModalEdit, setShowModalEdit] = useState(false);
    const handleCloseEdit = () => setShowModalEdit(false);
    const handleShowEdit = () => setShowModalEdit(true);

    // Modal Fullscreen Question
    //let table = null;
    const [showModalQuestion, setShowModalQuestion] = useState(false);
    const handleCloseQuestion = () => {
        setSelectedSubject(null);
        setSubjectName('');
        setQuestions(null);
        setShowKeywordTools(false);
        setKeywordTableFilter('all');
        setShowModalQuestion(false);
    }
    const handleShowQuestion = () => {
        hideLoader();
        setShowModalQuestion(true)
    };
    const values = [true,];
    const [fullscreen, setFullscreen] = useState(true);
    
    const [questions, setQuestions] = useState(null);
    const [quizQuestions, setQuizQuestions] = useState([]);

    const [showImportQuestions, setShowImportQuestions] = useState(false);
    const [importPdfFile, setImportPdfFile] = useState(null);
    const [isImportingQuestions, setIsImportingQuestions] = useState(false);
    const [importReport, setImportReport] = useState(null);
    const [isAddSubjectImportMode, setIsAddSubjectImportMode] = useState(false);
    const [importAllPdfType, setImportAllPdfType] = useState('ecampus');
    const [importAllPdfFile, setImportAllPdfFile] = useState(null);
    const [isImportingAllPdf, setIsImportingAllPdf] = useState(false);
    const [importAllReport, setImportAllReport] = useState(null);
    const [isRegeneratingKeywords, setIsRegeneratingKeywords] = useState(false);
    const [keywordRegenerationReport, setKeywordRegenerationReport] = useState(null);
    const [showKeywordTools, setShowKeywordTools] = useState(false);
    const [keywordTableFilter, setKeywordTableFilter] = useState('all');
    const [keywordPromptCopyMessage, setKeywordPromptCopyMessage] = useState('');
    const isImportingPdf = isImportingQuestions || isImportingAllPdf;
    const importPreloader = (
        <ImportPreloader
            show={isImportingPdf}
            title={text.importPreloaderTitle}
            message={text.importPreloaderMessage}
            hint={text.importPreloaderHint}
        />
    );

    const [showCompleteAnswers, setShowCompleteAnswers] = useState(false);
    const [completionMode, setCompletionMode] = useState('closed');
    const [questionsToComplete, setQuestionsToComplete] = useState([]);
    const [completionQuestionIndex, setCompletionQuestionIndex] = useState(0);
    const [completionAnswers, setCompletionAnswers] = useState({});
    const [initialCompletionAnswers, setInitialCompletionAnswers] = useState({});
    const [showCompleteCloseConfirm, setShowCompleteCloseConfirm] = useState(false);
    const [selectedPassage, setSelectedPassage] = useState(null);

    // Modal Add Question & Answers
    const [showModalAddQuestion, setShowAddQuestion] = useState(false);
    const handleCloseAddQuestion = () => {
        setShowAddQuestion(false);
        clearParamsQuestionAnswersContext();
    };
    const handleShowAddQuestion = () => {
            
        setShowAddQuestion(true);
    };

    //Fixing Params Form
    const [questionToAdd, setQuestionToAdd] = useState('');
    const questionToAddRef = useRef(null);

    const [isOpenedQuestion, setOpenedQuestion] = useState(false);
    const [isMultiple, setIsMultiple] = useState(false);
    const isMultipleRef = useRef(null);

    const [answersToAdd, setAnswersToAdd] = useState([{ text: '', isCorrect: false }, { text: '', isCorrect: false }]);

    //Clear Params Form
    const clearParamsQuestionAnswersContext = () => {
        setQuestionToAdd('');
        setOpenedQuestion(false);
        setIsMultiple(false);
        setAnswersToAdd([{ text: '', isCorrect: false }, { text: '', isCorrect: false }]);
    }

    const clearParamsQuestionAnswersRef= () => {
        questionToAddRef.current.value='';
    }

    // Effetto che viene eseguito dopo che isOpenedQuestion e/o isMultiple cambia
    useEffect(() => {
        // Questo effetto verrà eseguito subito dopo che lo stato isOpenedQuestion è stato aggiornato
        if(isOpenedQuestion && isMultiple){
            setIsMultiple(!isMultiple);
            isMultipleRef.current.checked = !isMultiple;
        }
        
        
    }, [isOpenedQuestion, isMultiple]);

    // Effetto che viene eseguito dopo che isOpenedQuestion e/o isMultiple cambia
    useEffect(() => {
        // Questo effetto verrà eseguito subito dopo che lo stato isOpenedQuestion è stato aggiornato
        if(isOpenedQuestion && isMultiple){
            setIsMultiple(!isMultiple);
            isMultipleRef.current.checked = !isMultiple;
        }

        if(!isOpenedQuestion){
            setAnswersToAdd([{text: '', isCorrect: false }, {text: '', isCorrect: false }])
        } else {
            setAnswersToAdd([{text: '', isCorrect: true }])
        }
        
    }, [isOpenedQuestion]);

    // Effetto che viene eseguito dopo che isOpenedQuestion e/o isMultiple cambia
    useEffect(() => {
        // Deseleziona tutte le risposte quando si passa a 'singola'
        if (!isOpenedQuestion && !isMultiple) {
            setAnswersToAdd(prevAnswers =>
            prevAnswers.map(answer => ({
                ...answer,
                isCorrect: false // Deseleziona tutte le risposte
            }))
            );
        }
    }, [isMultiple]);

    useEffect(() => {
        if (!showModalQuiz || !timerRef.current?.flatpickr) {
            return;
        }

        timerRef.current.flatpickr.setDate(formatMinutesForTimer(quizParams.timer), false);
    }, [showModalQuiz, quizParams.timer]);

    const handleSetAnswers = (index, field, value) => {
        const updatedAnswers = [...answersToAdd];
        updatedAnswers[index][field] = value;
        setAnswersToAdd(updatedAnswers);
    };

    // Gestione della selezione delle risposte corrette
    const handleSetCheckAnswers = (index) => {
        //alert("sono qui");

        if (isMultiple) {
            // Se è multipla, permette la selezione di più risposte corrette
            setAnswersToAdd((prevAnswers) =>
              prevAnswers.map((answer, idx) =>
                idx === index ? { ...answer, isCorrect: !answer.isCorrect } : answer
              )
            );
          } else {
            // Se è singola, deseleziona tutte le altre risposte e seleziona solo quella corrente
            setAnswersToAdd((prevAnswers) =>
              prevAnswers.map((answer, idx) => ({
                ...answer,
                isCorrect: idx === index // Seleziona solo quella corrente
              }))
            );
          }

        /*
    if (isMultiple) {
        // Se è multipla, permette la selezione di più risposte corrette
        handleSetAnswers(index, 'isCorrect', isChecked);
    } else {
        // Se è singola, deseleziona tutte le altre risposte e seleziona solo quella corrente
        const updatedAnswers = answersToAdd.map((answer, idx) => {
        return idx === index
            ? { ...answer, isCorrect: isChecked }
            : { ...answer, isCorrect: false };
        });
        setAnswersToAdd(updatedAnswers);
    }*/
    };

    const handleAddFieldAnswer = () => {
        setAnswersToAdd([...answersToAdd, { text: '', isCorrect: false }]);
    };

    // Funzione per eliminare una risposta
    const handleDelFieldAnswer = (index) => {
        if (answersToAdd.length > 2) {
            setAnswersToAdd(answersToAdd.slice(0, -1));
        }
    };

    const handleSubmitAddQuestion = async (e) => {
        e.preventDefault();
        //e.stopPropagation();
        /*
        alert("Simulazione: domanda aggiunta." + 
            "\nDomanda: " +  questionToAdd.toString() + 
            "\nTipo Domanda: " + (isOpenedQuestion ? "Aperta" : "Chiusa") +
            "\nTipo Risposta: " + (isMultiple ? "Multipla" : "Singola") +
            "\nRisposte: " + JSON.stringify(answersToAdd)
        );*/
        //console.log(answersToAdd);

        try {
            // 1. Raccogliere i dati dal form
            const questionData = {
              questionText: questionToAdd, // Assumi che 'questionToAdd' sia lo stato della tua textarea per la domanda
              questionType: isOpenedQuestion ? 'open' : 'closed', // Assumi che 'isOpenedQuestion' sia lo stato dello switch per il tipo di domanda
              answerType: isMultiple ? 'multiple' : 'single', // Assumi che 'isMultiple' sia lo stato per risposte multiple
              answers: answersToAdd, // Assumi che 'answersToAdd' sia uno stato che contiene le risposte [{ text: 'Risposta 1', isCorrect: false }, ...]
            };
            
            const  isCorrectAnswerSelected = answersToAdd.some(answer => answer.isCorrect);

            if(!isCorrectAnswerSelected){
                alert(text.validation.noCorrectAnswer);
            }

            // 2. Validare i dati della domanda (facoltativo, puoi anche fare la validazione nel backend)
            if (questionData.questionType === 'closed') {
              if (questionData.answers.length < 2) {
                alert(text.validation.closedNeedsTwoAnswers);
                return;
              }
        
              const hasCorrectAnswer = questionData.answers.some(answer => answer.isCorrect);
              if (!hasCorrectAnswer) {
                alert(text.validation.selectCorrectAnswer);
                return;
              }
            }
        
            // 3. Inviare i dati al backend
            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            const response = await axios.post(`${apiUrl}/addQuestion`, {
                subjectId: selectedSubject, // Assumi che 'selectedSubject' sia l'ID della materia corrente
                questionData: questionData,
              }, 
              {
                headers: {
                    'Authorization' : `Bearer ${token}`, // Passa il token JWT nell'header
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
            });
        
            // 4. Gestire la risposta del server
            if (response.status === 201) {
                alert(text.validation.addQuestionSuccess);
                // Aggiorna la tabella delle domande o fai altre azioni necessarie
                // Aggiungi la nuova domanda alla lista delle domande esistenti
                setQuestions([...questions, response.data]);
                 // Aggiorna i conteggi delle domande nel frontend
                 setSubjects((prevSubjects) => {
                    // Aggiorniamo i conteggi delle domande per la materia specificata
                    const updatedSubjects = prevSubjects.map((subject) => {
                      if (subject._id === selectedSubject._id) {
                        console.log("test");
                        return {
                          ...subject,
                          totalQuestions: subject.totalQuestions + 1, // Incrementa il totale delle domande
                          openQuestions: subject.openQuestions + (response.data.questionType === 'open' ? 1 : 0),
                          closedQuestions: subject.closedQuestions + (response.data.questionType === 'closed' ? 1 : 0),
                          missingCorrectAnswers: (subject.missingCorrectAnswers || 0) + (isClosedQuestionMissingCorrectAnswer(response.data) ? 1 : 0),
                          missingOpenAnswers: (subject.missingOpenAnswers || 0) + (isOpenQuestionMissingAnswer(response.data) ? 1 : 0),
                        };
                      }
                      return subject; // Restituisci le altre materie non modificate
                    });
                  
                    // Ora ordiniamo alfabeticamente per nome le materie aggiornate
                    return updatedSubjects.sort((a, b) => 
                      a.name.localeCompare(b.name, undefined, { caseFirst: 'upper' })
                    );
                  });
                  fetchArchives();
                //alert("Questions: ", questions);
                //console.log("fetch Questions:", questions);
              
            } else {
              alert(text.validation.addQuestionError);
            }

            handleCloseAddQuestion();

          } catch (error) {
            console.error('Errore durante l\'aggiunta della domanda: ', error);
            alert(text.validation.addQuestionRetry);
          }
          
    }

    const [subjectName, setSubjectName] = useState(''); // Stato per la modifica, eliminazione e domande della materia

    const [selectedSubject, setSelectedSubject] = useState(null); // Per memorizzare la materia selezionata
    const [archives, setArchives] = useState([]);
    const [selectedArchive, setSelectedArchive] = useState(null);
    const [isArchiveSwitching, setIsArchiveSwitching] = useState(false);
    const [isArchivesLoading, setIsArchivesLoading] = useState(true);
    const [archivesError, setArchivesError] = useState('');
    const [showAddArchive, setShowAddArchive] = useState(false);
    const [archiveName, setArchiveName] = useState('');
    const [archiveToDelete, setArchiveToDelete] = useState(null);
    const [archiveDeleteConfirmation, setArchiveDeleteConfirmation] = useState('');
    const [isDeletingArchive, setIsDeletingArchive] = useState(false);
    const archiveNameRef = useRef(null);
    const archiveSwitchTimeoutRef = useRef(null);

    //Alert NoSubject
    const [showAlert1, setShowAlert1] = useState(true);
    const [showArchiveAlert, setShowArchiveAlert] = useState(true);

    const [subjects, setSubjects] = useState([]); // Stato per memorizzare le materie
    const [isSubjectsLoading, setIsSubjectsLoading] = useState(true);
    const [subjectsError, setSubjectsError] = useState('');

    //const [loading, setLoading] = useState(false); // Stato di caricamento / Loader
    const { showLoader, hideLoader } = useLoader(); // Usa le funzioni del loader

    const nameRef = useRef(null);
    const descriptionRef = useRef(null);

    const [name, setName] = useState(''); // Stato per la nuova materia
    const [description, setDesc] = useState(''); // Stato per la descrizione (opzionale)
 
    /*
    const [formDataSubject, setFormDataSubject] = useState({
        name: '',
        desc: '',
    });*/

    // Funzione per ottenere le domande
    const fetchQuestions = async (idSubject) => {
        const resolvedSubjectId = typeof idSubject === 'object' ? idSubject?._id : idSubject;
        
        try {
            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            const response = await axios.post(`${apiUrl}/getQuestions`, {subjectId: resolvedSubjectId}, {
                headers: {
                    'Authorization' : `Bearer ${token}`, // Passa il token JWT nell'header
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 201 && response.data) {
                setQuestions(response.data);
                return response.data;
            }

            setQuestions([]);
            return [];
        } catch (error) {
            console.error('Errore nel recupero delle domande:', error);
            if (isAuthError(error)) {
                return [];
            }
            alert(text.validation.fetchQuestionsError + ' ' + (error.response?.data?.message || error.message));
            return [];
        }
    }; 

    const prepareCompletionAnswers = (targetQuestions) => {
        return targetQuestions.reduce((acc, question) => {
            if (question.questionType === 'open') {
                acc[question._id] = question.answers?.[0]?.text || '';
                return acc;
            }

            acc[question._id] = (question.answers || [])
                .map((answer, index) => (answer.isCorrect ? index : null))
                .filter((index) => index !== null);
            return acc;
        }, {});
    };

    const serializeCompletionAnswers = (answers) => (
        JSON.stringify(
            Object.keys(answers)
                .sort()
                .reduce((acc, questionId) => {
                    acc[questionId] = Array.isArray(answers[questionId])
                        ? [...(answers[questionId] || [])].sort((a, b) => a - b)
                        : String(answers[questionId] || '');
                    return acc;
                }, {})
        )
    );

    const handleShowCompleteAnswers = (targetQuestions = [], mode = 'closed') => {
        const questionFilter = mode === 'open'
            ? isOpenQuestionMissingAnswer
            : isClosedQuestionMissingCorrectAnswer;
        const questionsWithoutAnswer = targetQuestions.length
            ? targetQuestions
            : (Array.isArray(questions) ? questions.filter(questionFilter) : []);
        const preparedAnswers = prepareCompletionAnswers(questionsWithoutAnswer);

        setCompletionMode(mode);
        setQuestionsToComplete(questionsWithoutAnswer);
        setCompletionQuestionIndex(0);
        setCompletionAnswers(preparedAnswers);
        setInitialCompletionAnswers(preparedAnswers);
        setShowCompleteCloseConfirm(false);
        setShowCompleteAnswers(true);
    };

    const handleCloseCompleteAnswers = () => {
        setShowCompleteAnswers(false);
        setCompletionMode('closed');
        setQuestionsToComplete([]);
        setCompletionQuestionIndex(0);
        setCompletionAnswers({});
        setInitialCompletionAnswers({});
        setShowCompleteCloseConfirm(false);
    };

    const hasUnsavedCompletionChanges = () => (
        serializeCompletionAnswers(completionAnswers) !== serializeCompletionAnswers(initialCompletionAnswers)
    );

    const handleRequestCloseCompleteAnswers = () => {
        if (hasUnsavedCompletionChanges()) {
            setShowCompleteCloseConfirm(true);
            return;
        }

        handleCloseCompleteAnswers();
    };

    const handleSetCompletionAnswer = (question, answerIndex) => {
        setShowCompleteCloseConfirm(false);
        setCompletionAnswers((prevAnswers) => {
            const currentAnswers = prevAnswers[question._id] || [];

            if (question.answerType === 'multiple') {
                return {
                    ...prevAnswers,
                    [question._id]: currentAnswers.includes(answerIndex)
                        ? currentAnswers.filter((index) => index !== answerIndex)
                        : [...currentAnswers, answerIndex],
                };
            }

            return {
                ...prevAnswers,
                [question._id]: [answerIndex],
            };
        });
    };

    const handleSetOpenCompletionAnswer = (question, value) => {
        setShowCompleteCloseConfirm(false);
        setCompletionAnswers((prevAnswers) => ({
            ...prevAnswers,
            [question._id]: value,
        }));
    };

    const handleSubmitCompleteAnswers = async (e, shouldCloseAfterSave = true) => {
        e.preventDefault();

        const isOpenCompletion = completionMode === 'open';
        const missingSelections = isOpenCompletion
            ? []
            : questionsToComplete.filter((question) => !(completionAnswers[question._id] || []).length);

        if (missingSelections.length) {
            alert(text.validation.selectCorrectAnswerForAll);
            return;
        }

        try {
            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            const response = await axios.post(`${apiUrl}/${isOpenCompletion ? 'completeOpenQuestionAnswers' : 'completeQuestionAnswers'}`, {
                questions: questionsToComplete.map((question) => (
                    isOpenCompletion
                        ? {
                            questionId: question._id,
                            answerText: completionAnswers[question._id] || '',
                        }
                        : {
                            questionId: question._id,
                            correctAnswerIndexes: completionAnswers[question._id] || [],
                        }
                )),
            }, {
                headers: {
                    'Authorization' : `Bearer ${token}`,
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                const updatedQuestions = response.data.questions || [];

                setQuestions((prevQuestions) => (
                    Array.isArray(prevQuestions)
                        ? prevQuestions.map((question) => updatedQuestions.find((updatedQuestion) => updatedQuestion._id === question._id) || question)
                        : prevQuestions
                ));
                setSubjects((prevSubjects) => prevSubjects.map((subject) => (
                    subject._id === selectedSubject?._id
                        ? {
                            ...subject,
                            missingCorrectAnswers: isOpenCompletion
                                ? subject.missingCorrectAnswers
                                : Math.max(0, (subject.missingCorrectAnswers || 0) - updatedQuestions.length),
                            missingOpenAnswers: isOpenCompletion
                                ? Math.max(0, (subject.missingOpenAnswers || 0) - updatedQuestions.filter((question) => !isOpenQuestionMissingAnswer(question)).length)
                                : subject.missingOpenAnswers,
                        }
                        : subject
                )));

                alert(isOpenCompletion ? text.validation.completeOpenAnswersSuccess : text.validation.completeAnswersSuccess);
                setInitialCompletionAnswers(prepareCompletionAnswers(updatedQuestions));
                setShowCompleteCloseConfirm(false);

                if (shouldCloseAfterSave) {
                    handleCloseCompleteAnswers();
                }
            }
        } catch (error) {
            console.error('Errore durante il completamento delle risposte:', error);
            alert(text.validation.completeAnswersError + ' ' + (error.response?.data?.message || error.message));
        }
    };

    const handleShowImportQuestions = () => {
        setImportPdfFile(null);
        setImportReport(null);
        setShowImportQuestions(true);
    };

    const handleCloseImportQuestions = () => {
        if (isImportingQuestions) {
            return;
        }

        setShowImportQuestions(false);
        setImportPdfFile(null);
        setImportReport(null);
        setIsImportingQuestions(false);
    };

    const handleSubmitImportAllPdf = async (e) => {
        e.preventDefault();

        if (!importAllPdfFile) {
            return;
        }

        const formData = new FormData();
        formData.append('pdf', importAllPdfFile);
        formData.append('importType', importAllPdfType);
        formData.append('archiveId', selectedArchive?._id || '');

        try {
            setIsImportingAllPdf(true);

            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            const response = await axios.post(`${apiUrl}/importSubjectPdf`, formData, {
                headers: {
                    'Authorization' : `Bearer ${token}`,
                    'Accept' : 'application/json',
                }
            });

            if (response.status === 201) {
                const importedSubject = response.data.subject;
                const importedSubjects = response.data.subjects || (importedSubject ? [importedSubject] : []);
                setImportAllReport(response.data);

                if (importedSubjects.length) {
                    setSubjects((prevSubjects) => {
                        const importedSubjectIds = new Set(importedSubjects.map((subject) => subject._id));
                        const withoutImportedSubjects = prevSubjects.filter((subject) => !importedSubjectIds.has(subject._id));
                        return [...withoutImportedSubjects, ...importedSubjects].sort((a, b) =>
                            a.name.localeCompare(b.name, undefined, {caseFirst: 'upper' })
                        );
                    });
                }
                fetchArchives();
            }
        } catch (error) {
            console.error("Errore durante l'importazione completa del PDF:", error);
            alert(text.validation.importPdfError + ' ' + (error.response?.data?.message || error.message));
        } finally {
            setIsImportingAllPdf(false);
        }
    };

    const handleSubmitImportQuestions = async (e) => {
        e.preventDefault();

        if (!importPdfFile) {
            alert(text.validation.choosePdf);
            return;
        }

        const formData = new FormData();
        formData.append('pdf', importPdfFile);
        formData.append('subjectId', selectedSubject._id);

        try {
            setIsImportingQuestions(true);

            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            const response = await axios.post(`${apiUrl}/importQuestionsPdf`, formData, {
                headers: {
                    'Authorization' : `Bearer ${token}`,
                    'Accept' : 'application/json',
                }
            });

            if (response.status === 201) {
                setImportReport(response.data);
                await fetchQuestions(selectedSubject._id);

                if (response.data.subject) {
                    setSelectedSubject(response.data.subject);
                    setSubjects((prevSubjects) => prevSubjects.map((subject) => {
                        if (subject._id !== selectedSubject._id) {
                            return subject;
                        }

                        return response.data.subject;
                    }).sort((a, b) =>
                        a.name.localeCompare(b.name, undefined, { caseFirst: 'upper' })
                    ));
                }

                fetchArchives();
            }
        } catch (error) {
            console.error("Errore durante l'importazione del PDF:", error);
            alert(text.validation.importPdfError + ' ' + (error.response?.data?.message || error.message));
        } finally {
            setIsImportingQuestions(false);
        }
    };

    const handleSaveAvailableKeywords = async () => {
        if (!selectedSubject?._id || isRegeneratingKeywords) {
            return;
        }

        try {
            setIsRegeneratingKeywords(true);
            setKeywordRegenerationReport(null);

            const keywordPayload = questionsWithAutomaticKeyword
                .map((question) => ({
                    questionId: question._id,
                    keywordHint: getAutomaticKeywordHint(question, text),
                }))
                .filter((item) => item.questionId && item.keywordHint);

            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            const response = await axios.post(`${apiUrl}/saveQuestionKeywords`, {
                subjectId: selectedSubject._id,
                keywords: keywordPayload,
            }, {
                headers: {
                    'Authorization' : `Bearer ${token}`,
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                setKeywordRegenerationReport(response.data);
                setShowKeywordTools(false);
                await fetchQuestions(selectedSubject);
            }
        } catch (error) {
            console.error('Errore durante il salvataggio delle parole chiave:', error);
            alert(text.validation.saveKeywordsError + ' ' + (error.response?.data?.message || error.message));
        } finally {
            setIsRegeneratingKeywords(false);
        }
    };

    const handleShowKeywordTools = (event) => {
        clearActiveButtonFocus(event);
        setShowKeywordTools(true);
    };

    const handleCloseKeywordTools = (event) => {
        clearActiveButtonFocus(event);
        setShowKeywordTools(false);
    };

    const handleShowKeywordToolQuestions = (filterType, event) => {
        clearActiveButtonFocus(event);
        setKeywordTableFilter(filterType || (hasMissingKeywordQuestions ? 'missingKeywords' : 'unsavedKeywords'));
        setShowKeywordTools(false);
    };

    const handleShowAllKeywordQuestions = (event) => {
        clearActiveButtonFocus(event);
        setKeywordTableFilter('all');
    };

    const buildKeywordPrompt = (targetQuestions = [], promptType = keywordTableFilter) => {
        const questionList = Array.isArray(targetQuestions) ? targetQuestions : [];
        const filterLabel = promptType === 'missingKeywords'
            ? 'senza keyword'
            : promptType === 'unsavedKeywords'
                ? 'keyword da salvare'
                : 'tutte';
        const typeInstructions = promptType === 'missingKeywords'
            ? [
                'TIPO CASI: KEYWORD MANCANTI.',
                'Queste domande non hanno keyword salvata e il generatore automatico NON ha trovato un suggerimento affidabile.',
                'Obiettivo principale: capire se esiste una regola generalizzabile e sicura per migliorare il parser/generatore keyword, poi applicarla in modo circoscritto.',
                'Proponi una keyword automatica solo se esiste nella risposta corretta una parola, frase breve, sigla, numero o frammento davvero distintivo rispetto alle alternative sbagliate.',
                'Se la risposta corretta si distingue solo perché NON contiene una parola/frase presente nelle sbagliate, non trasformarla in keyword automatica: segna "scrivere manualmente" e, al massimo, suggerisci una nota mnemonica separata tipo "senza: ...".',
                'Non forzare keyword deboli: meglio lasciare manuale un caso ambiguo che salvare una keyword che evidenzia parole comuni o tutta la risposta.',
            ]
            : promptType === 'unsavedKeywords'
                ? [
                    'TIPO CASI: KEYWORD AUTOMATICHE DA SALVARE.',
                    'Queste domande non hanno keyword salvata, ma il generatore automatico ha prodotto una keyword candidata.',
                    'Obiettivo principale: verificare se la keyword candidata è davvero salvabile. Se non lo è, correggere il parser/generatore perché in casi simili proponga una keyword migliore o lasci il caso manuale.',
                    'Tieni una keyword solo se evidenzia una parte breve, visibile e distintiva della risposta corretta.',
                    'Sostituiscila se è troppo lunga, comune, presente anche nelle risposte sbagliate, tagliata male, oppure se evidenzia quasi tutta la risposta.',
                    'Indica "scrivere manualmente" quando nessuna regola automatica sicura può distinguere la risposta corretta senza rischiare regressioni.',
                ]
                : [
                    'TIPO CASI: LISTA MISTA.',
                    'Distingui tra keyword automatiche da validare e keyword mancanti da risolvere, ma mantieni le due analisi separate.',
                ];
        const questionBlocks = questionList
            .filter((question) => question?.questionType === 'closed')
            .map((question, index) => {
                const answers = Array.isArray(question.answers) ? question.answers : [];
                const correctAnswers = answers.filter((answer) => answer.isCorrect);
                const wrongAnswers = answers.filter((answer) => !answer.isCorrect);
                const savedKeyword = getSavedKeywordHint(question);
                const automaticKeyword = getAutomaticKeywordHint(question, text);
                const status = savedKeyword
                    ? 'keyword salvata'
                    : automaticKeyword
                        ? 'keyword automatica da verificare/salvare'
                        : 'senza keyword automatica';

                return [
                    `${index + 1}. ID domanda: ${question._id || '-'}`,
                    `Domanda: ${question.questionText || ''}`,
                    `Risposta corretta: ${correctAnswers.map((answer) => answer.text).join(' | ') || 'NON TROVATA'}`,
                    wrongAnswers.length
                        ? `Risposte sbagliate:\n${wrongAnswers.map((answer) => `- ${answer.text}`).join('\n')}`
                        : 'Risposte sbagliate: -',
                    `Keyword salvata: ${savedKeyword || '-'}`,
                    `Keyword automatica/proposta: ${automaticKeyword || '-'}`,
                    `Stato: ${status}`,
                ].join('\n');
            });

        if (!questionBlocks.length) {
            return '';
        }

        return [
            'Analizza SOLO questi casi problematici di Quizify.',
            'Questo prompt è pensato per Codex: non chiedere all’utente cosa fare e non limitarti a dare consigli manuali. Se hai accesso al repo, correggi direttamente parser/generatore keyword e verifica il comportamento.',
            'Contesto: Quizify salva/evidenzia parole chiave nelle risposte corrette dei quiz. Le domande non incluse in questo prompt sono considerate già riconosciute correttamente.',
            'Obiettivo: migliorare il riconoscimento automatico solo per i pattern rappresentati dai casi sotto, senza cambiare o rompere i casi già funzionanti.',
            'Per ogni domanda valuta se la keyword proposta o mancante aiuta davvero a riconoscere la risposta corretta senza evidenziare tutta la risposta.',
            'Preferisci keyword brevi, visibili e memorizzabili: differenze lessicali, parole uniche, sigle, numeri, parole tra parentesi/virgolette, frammenti distintivi della risposta corretta.',
            'Una keyword può essere anche una combinazione di indizi: ogni singola parola/frase non deve per forza essere unica in assoluto, se l’insieme degli indizi identifica solo la risposta corretta.',
            'Evita keyword generate da parole comuni, stopword, pezzi presenti anche nelle alternative sbagliate, o differenze basate solo sull’assenza di parole nella risposta corretta.',
            'Se serve modificare il parser/generatore, la correzione deve essere circoscritta, spiegare il pattern coperto e indicare quale regressione evitare.',
            'Risultato atteso: implementa la patch se puoi. Se non puoi modificare il codice, restituisci per ogni ID domanda: "tenere", "sostituire con", oppure "scrivere manualmente", più la regola parser/generatore da aggiungere.',
            '',
            ...typeInstructions,
            '',
            `Materia: ${selectedSubject?.name || subjectName || '-'}`,
            `Filtro: ${filterLabel}`,
            `Domande incluse: ${questionBlocks.length}`,
            '',
            questionBlocks.join('\n\n---\n\n'),
        ].join('\n').trim();
    };

    const copyTextToClipboard = async (value) => {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(value);
            return;
        }

        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
    };

    const handleCopyKeywordPrompt = async (event, promptType = keywordTableFilter) => {
        clearActiveButtonFocus(event);
        const promptQuestions = promptType === 'missingKeywords'
            ? missingKeywordQuestions
            : promptType === 'unsavedKeywords'
                ? questionsWithAutomaticKeyword
                : visibleQuestionRows;
        const prompt = buildKeywordPrompt(promptQuestions, promptType);

        if (!prompt) {
            setKeywordPromptCopyMessage(text.keywordPromptEmpty);
            return;
        }

        try {
            await copyTextToClipboard(prompt);
            setKeywordPromptCopyMessage(text.keywordPromptCopied);
        } catch (error) {
            console.error('Errore durante la copia del prompt keyword:', error);
            setKeywordPromptCopyMessage(text.keywordPromptCopyError);
        }
    };

    const handleCloseAddArchive = () => {
        setShowAddArchive(false);
        setArchiveName('');
        if (archiveNameRef.current) {
            archiveNameRef.current.value = '';
        }
    };

    const handleShowDeleteArchive = (archive) => {
        setArchiveToDelete(archive);
        setArchiveDeleteConfirmation('');
    };

    const handleCloseDeleteArchive = () => {
        setArchiveToDelete(null);
        setArchiveDeleteConfirmation('');
    };

    const handleShowAddArchive = () => {
        setArchiveName('');
        setShowAddArchive(true);
    };

    const handleSelectArchive = (archive) => {
        if (archiveSwitchTimeoutRef.current) {
            clearTimeout(archiveSwitchTimeoutRef.current);
        }

        setIsArchiveSwitching(true);
        archiveSwitchTimeoutRef.current = setTimeout(() => {
            setSelectedArchive(archive);
            setIsArchiveSwitching(false);
            navigate('/archives/subjects');
        }, 150);
    };

    const fetchArchives = async () => {
        if (isAuthLoading) {
            return;
        }

        setIsArchivesLoading(true);
        setArchivesError('');

        try {
            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            if (!token) {
                setArchivesError(text.validation.invalidSession || 'Sessione non valida.');
                return;
            }

            const response = await axios.post(`${apiUrl}/getArchives`, {}, {
                headers: {
                    'Authorization' : `Bearer ${token}`,
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            const archiveList = Array.isArray(response.data) ? response.data : [];
            setArchives(archiveList);

            if (selectedArchive) {
                const refreshedArchive = archiveList.find((archive) => archive._id === selectedArchive._id);
                setSelectedArchive(refreshedArchive || null);
            }
        } catch (error) {
            console.error('Errore nel recupero degli archivi:', error);
            setArchivesError(text.validation.fetchArchivesError + ' ' + (error.response?.data?.message || error.message));
        } finally {
            setIsArchivesLoading(false);
        }
    };

    const handleSubmitAddArchive = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem('token') || sessionStorage.getItem('token');

        try {
            const response = await axios.post(`${apiUrl}/addArchive`, { name: archiveName }, {
                headers: {
                    'Authorization' : `Bearer ${token}`,
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 201) {
                const updatedArchives = [...archives, response.data].sort((a, b) =>
                    a.name.localeCompare(b.name, undefined, {caseFirst: 'upper' })
                );
                setArchives(updatedArchives);
                setSelectedArchive(response.data);
                setSubjects([]);
                handleCloseAddArchive();
            }
        } catch (error) {
            alert(text.validation.addArchiveError + ' ' + (error.response?.data?.message || error.message));
        }
    };

    const handleConfirmDeleteArchive = async (e) => {
        e.preventDefault();

        if (!archiveToDelete) {
            return;
        }

        try {
            setIsDeletingArchive(true);

            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            const response = await axios.post(`${apiUrl}/delArchive`, {
                id: archiveToDelete._id,
                confirmation: archiveDeleteConfirmation,
            }, {
                headers: {
                    'Authorization' : `Bearer ${token}`,
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 201) {
                setArchives((prevArchives) => prevArchives.filter((archive) => archive._id !== archiveToDelete._id));

                if (selectedArchive?._id === archiveToDelete._id) {
                    setSelectedArchive(null);
                    setSubjects([]);
                    setQuestions(null);
                }

                handleCloseDeleteArchive();
            }
        } catch (error) {
            console.error("Errore durante l'eliminazione dell'archivio:", error);
            alert(text.validation.deleteArchiveError + ' ' + (error.response?.data?.message || error.message));
        } finally {
            setIsDeletingArchive(false);
        }
    };

    // Funzione per ottenere le materie
    const fetchSubjects = async () => {
        if (isAuthLoading) {
            return;
        }

        if (!selectedArchive) {
            setSubjects([]);
            setIsSubjectsLoading(false);
            return;
        }

        setIsSubjectsLoading(true);
        setSubjectsError('');

        try {
            const token = localStorage.getItem('token') || sessionStorage.getItem('token');
            if (!token) {
                setSubjectsError(text.validation.invalidSession || 'Sessione non valida.');
                return;
            }

            //alert(token);
            const response = await axios.post(`${apiUrl}/getSubjects`, { archiveId: selectedArchive._id }, {
                headers: {
                    'Authorization' : `Bearer ${token}`, // Passa il token JWT nell'header
                    'Accept' : 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            const listSubject = Array.isArray(response.data) ? response.data : [];
            setSubjects(
                listSubject.sort((a, b) =>
                    a.name.localeCompare(b.name, undefined, {caseFirst: 'upper' })
                )
            );
        } catch (error) {
            console.error('Errore nel recupero delle materie:', error);
            if (!isAuthError(error)) {
                setSubjectsError(text.validation.fetchSubjectsError + ' ' + (error.response?.data?.message || error.message));
            }
        } finally {
            setIsSubjectsLoading(false);
        }
    }; 

    // Effetto per recuperare le materie una volta che il componente è montato
    useEffect(() => {
        fetchSubjects();
    }, [isAuthLoading, selectedArchive]); // Si esegue quando l'autenticazione è pronta

    useEffect(() => {
        fetchArchives();
    }, [isAuthLoading]);

    useEffect(() => {
        if (location.pathname === '/archives/subjects' && !selectedArchive) {
            navigate('/archives', { replace: true });
        }
    }, [location.pathname, navigate, selectedArchive]);

    useEffect(() => () => {
        if (archiveSwitchTimeoutRef.current) {
            clearTimeout(archiveSwitchTimeoutRef.current);
        }
    }, []);

    useEffect(() => {
        if (!isImportingPdf) {
            return undefined;
        }

        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = '';
            return '';
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isImportingPdf]);

    /*
    const handleChangeAddSubject = (e) => {
        const { name, value, type, checked } = e.target;
        setFormDataSubject({
          ...formDataSubject,
          [name]: type === 'checkbox' ? checked : value,
        });
     };*/

    const handleSubmitAddSubject = async (e) => {
        e.preventDefault();
        //e.stopPropagation();
        //alert("inviato");
        //console.log("inviato");
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        //alert(token);
        try{
            const res = await axios.post(`${apiUrl}/addSubject`, {name, description, archiveId: selectedArchive?._id}, {headers: {
                'Authorization' : `Bearer ${token}`, // Passa il token JWT nell'header
                'Accept' : 'application/json',
                'Content-Type': 'application/json'}}
            ).then(function (response) {
            console.log(response);
            if(response.status === 201){
               if(response.data){
                    //setSubjects([...subjects, response.data]);
                    // Aggiungi le proprietà direttamente a response.data
                    response.data.totalQuestions = 0;
                    response.data.closedQuestions = 0;
                    response.data.openQuestions = 0;
                    // Aggiungi la nuova materia e riordina in ordine alfabetico
                    const updatedSubject = [...subjects, response.data];
                        // Aggiorna lo stato con le materie recuperate
                    setSubjects(() => {
                        // Riordina alfabeticamente per nome
                        return updatedSubject.sort((a, b) => 
                            a.name.localeCompare(b.name, undefined, {caseFirst: 'upper' })
                        );
                    });
                    //setSubjects(updatedSubjects); // Aggiorna lo stato con le materie ordinate
                    setName(''); // Resetta il campo nome
                    setDesc(''); // Resetta il campo descrizione
                    nameRef.current.value = ''; // Resetta il campo nome nel Modal
                    setShowAddSubject(false);
                    fetchArchives();
               }
            }
         })
         .catch(function (error) {
            //console.log(error);
            alert(text.validation.addSubjectError + ' ' + error.response.data.message);
         });
      } catch (error) {
         // Controlla se error.response esiste
         if (error.response) {
             // Il server ha risposto con uno status diverso da 2xx
             alert(text.validation.serverResponseError + ' ' + (error.response.data?.message || ''));
             
             if (error.response.data) {
               alert(error.response.data.message);
             }
         } else if (error.request) {
             // La richiesta è stata fatta, ma non c'è stata alcuna risposta
             alert(text.validation.requestError + ' ' + error.request);
         } else {
             // Altro tipo di errore durante la creazione della richiesta
             alert(text.validation.genericError + ' ' + error.message);
         }
        }
    }

    const handleDeleteClick = (subject) => {
        setSelectedSubject(subject); // Salva la materia selezionata
        handleShowDel(); // Mostra la modale
    };

    const handleConfirmDelete = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (selectedSubject) {
          try {
            const response = await axios.post(`${apiUrl}/delSubject`, {id: selectedSubject._id}, {headers: {
                'Authorization' : `Bearer ${token}`, // Passa il token JWT nell'header
                'Accept' : 'application/json',
                'Content-Type': 'application/json'}}
            )

            if (response.status === 201) {
              // Aggiorna l'elenco delle materie
              alert(response.data.message);
              setSubjects(subjects.filter(subject => subject._id !== selectedSubject._id));
              fetchArchives();
              setSelectedSubject(null); // Resetta la materia selezionata
              setSubjectName('');
              setShowModalDel(false); // Chiudi la modale
            }
          } catch (error) {
            console.error('Errore durante l\'eliminazione della materia', error);
          }
        }
    };

    const handleEditClick = (subject) => {
        setSelectedSubject(subject); // Salva la materia selezionata
        //alert(JSON.stringify(subject.name));
        setSubjectName(subject.name);
        handleShowEdit(); // Mostra la modale
    };

    const handleConfirmEdit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (selectedSubject) {
            //alert("Simulazione Modifica Eseguita");
            

          try {
            const response = await axios.post(`${apiUrl}/editSubject`, {id: selectedSubject._id, name: subjectName}, {headers: {
                'Authorization' : `Bearer ${token}`, // Passa il token JWT nell'header
                'Accept' : 'application/json',
                'Content-Type': 'application/json'}}
            ).then(function (response) {
                
                if(response.status === 201){
                   if(response.data){
                    //alert(JSON.stringify(response));
                    const updatedSubject = response.data;
        
                    // Aggiorna lo stato delle materie nel frontend e riordina alfabeticamente
                    setSubjects((prevSubjects) => {
                        // Filtra l'array per rimuovere il soggetto selezionato
                        const filteredSubjects = prevSubjects.filter(subject => subject._id !== selectedSubject._id);
                        
                        // Aggiungi il soggetto aggiornato
                        filteredSubjects.push(updatedSubject);
        
                        // Riordina alfabeticamente per nome
                        return filteredSubjects.sort((a, b) => 
                            a.name.localeCompare(b.name, undefined, {  caseFirst: 'upper' })
                        );
                    });
                    
                    setSelectedSubject(null); // Resetta la materia selezionata
                    setSubjectName(''); // Resetta il campo nome nel contesto
                    
                    handleCloseEdit(); // Chiudi la modale
                   }
                }
             })
             .catch(function (error) {
                //console.log(error);
                alert(text.validation.editSubjectError + ' ' + error.response.data.message);
             });
          } catch (error) {
            console.error('Errore durante l\'eliminazione della materia', error);
          }
        }
    };

    const handleQuestionClick = async (breakpoint, subject) => {
        //setLoading(true); // Mostra il loader
        showLoader("quest");
        setSelectedSubject(subject); // Salva la materia selezionata
        //alert(JSON.stringify(subject.name));
        setSubjectName(subject.name);
        setKeywordRegenerationReport(null);
        setShowKeywordTools(false);
        setKeywordTableFilter('all');
        fetchQuestions(subject);
        //setQuestions(sampleQuestions);
        /*
        const fetchQuestions = async () => {
            return Promise.resolve([
                {
                  question: 'What is the capital of France?',
                  answers: ['Berlin', 'Madrid', 'Paris', 'Rome'],
                  correctAnswer: 'Paris',
                },
                {
                  question: 'What is the capital of Italy?',
                  answers: ['Milan', 'Rome2', 'Venice', 'Naples'],
                  correctAnswer: 'Rome',
                },
              ]);
          };
      
          fetchQuestions().then(data => setQuestions(data));
          */
        setFullscreen(breakpoint);
        handleShowQuestion(); // Mostra la modale
    };

    const getMaxQuestionsForQuizParams = (nextQuizParams, sourceQuestions = questions) => {
        const availableQuestions = getQuestionsForQuizFilterByValue(nextQuizParams.questionFilter || 'all', sourceQuestions);
        const quizType = nextQuizParams.questionType || 'Closed';

        if (quizType === 'Open') {
            return availableQuestions.filter((question) => question.questionType === 'open').length;
        }

        if (quizType === 'Both') {
            return availableQuestions.length;
        }

        return availableQuestions.filter((question) => question.questionType === 'closed').length;
    };

    const normalizeQuizParams = (nextQuizParams, sourceQuestions = questions) => {
        const typedQuestions = getQuestionsByType(sourceQuestions, nextQuizParams.questionType || 'Closed');
        const filterAvailability = getQuestionFilterAvailability(typedQuestions);
        const safeQuestionFilter = filterAvailability[nextQuizParams.questionFilter] > 0
            ? nextQuizParams.questionFilter
            : 'all';
        const availableQuestions = getQuestionsForQuizFilterByValue(safeQuestionFilter, sourceQuestions);
        const maxQuestions = getMaxQuestionsForQuizParams(nextQuizParams, sourceQuestions);
        const numberOfQuestions = Math.min(
            Number(nextQuizParams.numberOfQuestions || maxQuestions || 1),
            Math.max(maxQuestions, 1)
        );
        const availableOpenQuestions = availableQuestions.filter((question) => question.questionType === 'open').length;

        return {
            ...nextQuizParams,
            questionFilter: safeQuestionFilter,
            showKeywords: nextQuizParams.showKeywords !== false,
            autoShowOpenAnswers: nextQuizParams.autoShowOpenAnswers === true,
            numberOfQuestions,
            numberOfOpenQuestions: nextQuizParams.questionType === 'Both'
                ? Math.min(Number(nextQuizParams.numberOfOpenQuestions || 0), availableOpenQuestions, numberOfQuestions)
                : 0,
        };
    };

    const getDefaultQuizParams = (subject, subjectQuestions = []) => {
        const closedQuestions = subjectQuestions.filter((question) => question.questionType === 'closed').length;
        const defaultQuestionType = closedQuestions > 0 ? 'Closed' : 'Open';

        return normalizeQuizParams({
            questionType: defaultQuestionType,
            numberOfQuestions: 30,
            timer: 0,
            numberOfOpenQuestions: 0,
            questionOrder: 'inserted',
            answerOrder: 'inserted',
            questionFilter: 'all',
            showKeywords: true,
            autoShowOpenAnswers: false,
        }, subjectQuestions);
    };

    const saveQuizSettingsForSubject = (subjectId, nextQuizParams) => {
        if (!subjectId) {
            return;
        }

        setQuizSettingsBySubjectId((previousSettings) => ({
            ...previousSettings,
            [subjectId]: nextQuizParams,
        }));
    };

    const formatMinutesForTimer = (minutesValue = 0) => {
        const safeMinutes = Math.max(0, Math.min(Number(minutesValue || 0), 480));
        const hours = Math.floor(safeMinutes / 60).toString().padStart(2, '0');
        const minutes = (safeMinutes % 60).toString().padStart(2, '0');

        return `${hours}:${minutes}`;
    };

    const shuffleItems = (items) => {
        const shuffledItems = [...items];

        for (let index = shuffledItems.length - 1; index > 0; index -= 1) {
            const randomIndex = Math.floor(Math.random() * (index + 1));
            [shuffledItems[index], shuffledItems[randomIndex]] = [shuffledItems[randomIndex], shuffledItems[index]];
        }

        return shuffledItems;
    };

    const orderAnswersForQuiz = (answerList = []) => {
        if (!Array.isArray(answerList)) {
            return [];
        }

        const answersWithStableIds = answerList.map((answer, answerIndex) => ({
            ...answer,
            _answerId: answer._answerId || `${answer.questionId || ''}-answer-${answerIndex}`,
        }));

        if (quizParams.answerOrder === 'random') {
            return shuffleItems(answersWithStableIds);
        }

        if (quizParams.answerOrder === 'correctFirst') {
            const orderedAnswers = [...answersWithStableIds];
            const correctAnswerIndex = orderedAnswers.findIndex((answer) => answer.isCorrect);

            if (correctAnswerIndex > 0) {
                [orderedAnswers[0], orderedAnswers[correctAnswerIndex]] = [orderedAnswers[correctAnswerIndex], orderedAnswers[0]];
            }

            return orderedAnswers;
        }

        return [...answersWithStableIds];
    };

    const applyAnswerOrderForQuiz = (questionList) => questionList.map((question) => ({
        ...question,
        answers: question.questionType === 'closed'
            ? orderAnswersForQuiz((question.answers || []).map((answer, answerIndex) => ({
                ...answer,
                _answerId: answer._answerId || `${question._id}-answer-${answerIndex}`,
            })))
            : question.answers,
    }));

    const buildQuizQuestions = () => {
        const availableQuestions = getQuestionsForQuizFilter();
        const quizType = quizParams.questionType || 'Closed';
        const requestedQuestions = Number(quizParams.numberOfQuestions || 0);
        const totalRequestedQuestions = requestedQuestions > 0 ? requestedQuestions : availableQuestions.length;
        const openQuestions = availableQuestions.filter((question) => question.questionType === 'open');
        const closedQuestions = availableQuestions.filter((question) => question.questionType === 'closed');

        const selectionOptions = {
            filterValue: quizParams.questionFilter,
            order: quizParams.questionOrder,
        };

        if (quizType === 'Open') {
            return applyAnswerOrderForQuiz(selectQuestionsForQuiz(openQuestions, totalRequestedQuestions, selectionOptions));
        }

        if (quizType === 'Both') {
            const requestedOpenQuestions = Math.min(
                Number(quizParams.numberOfOpenQuestions || 0),
                openQuestions.length,
                totalRequestedQuestions
            );
            const requestedClosedQuestions = Math.max(0, totalRequestedQuestions - requestedOpenQuestions);
            const selectedOpenQuestions = selectQuestionsForQuiz(openQuestions, requestedOpenQuestions, selectionOptions);
            const selectedClosedQuestions = selectQuestionsForQuiz(closedQuestions, requestedClosedQuestions, selectionOptions);
            const selectedQuestions = [...selectedClosedQuestions, ...selectedOpenQuestions];

            return applyAnswerOrderForQuiz(
                orderQuestionsByProgress(selectedQuestions, selectionOptions)
            );
        }

        return applyAnswerOrderForQuiz(selectQuestionsForQuiz(closedQuestions, totalRequestedQuestions, selectionOptions));
    };

    // Quiz Modal Function
    const handleSubmitQuiz = async (e) => {
        e.preventDefault();
        setFullscreen(true);
        const preparedQuizQuestions = buildQuizQuestions();

        if (!preparedQuizQuestions.length) {
            alert(text.validation.noQuestionsForQuizFilter);
            return;
        }

        const incompletePreparedClosedQuestions = preparedQuizQuestions.filter(isClosedQuestionMissingCorrectAnswer);

        if (incompletePreparedClosedQuestions.length) {
            const shouldStartAnyway = window.confirm(text.validation.startQuizWithIncompleteAnswers(incompletePreparedClosedQuestions.length));

            if (!shouldStartAnyway) {
                handleShowCompleteAnswers(incompletePreparedClosedQuestions);
                return;
            }
        }

        const nextQuizParams = {
            ...quizParams,
            numberOfQuestions: preparedQuizQuestions.length,
        };

        setQuizParams(nextQuizParams);
        saveQuizSettingsForSubject(selectedSubject?._id, nextQuizParams);
        setQuizQuestions(preparedQuizQuestions);
        setShowQuizScreen(true); // Mostra il quiz e nascondi la modale
    }

    // Funzione per aggiornare i parametri del quiz
    const handleChangeQuizParams = (e) => {
        const { name, value, checked, type } = e.target;
        const nextQuizParams = {
            ...quizParams,
            [name]: type === 'checkbox' ? checked : value,
            ...(name === 'questionType' && value !== 'Both' ? { numberOfOpenQuestions: 0 } : {}),
        };
        const questionFilter = nextQuizParams.questionFilter || 'all';
        const quizType = nextQuizParams.questionType || 'Closed';
        const filterAvailability = getQuestionFilterAvailability(getQuestionsByType(questions, quizType));

        if (!filterAvailability[questionFilter]) {
            nextQuizParams.questionFilter = 'all';
        }
        const availableQuestions = getQuestionsForQuizFilterByValue(nextQuizParams.questionFilter);
        const availableByType = quizType === 'Open'
            ? availableQuestions.filter((question) => question.questionType === 'open')
            : quizType === 'Both'
                ? availableQuestions
                : availableQuestions.filter((question) => question.questionType === 'closed');
        const maxAvailableQuestions = availableByType.length;

        if (['questionType', 'questionFilter'].includes(name) || (name === 'numberOfQuestions' && value !== '')) {
            nextQuizParams.numberOfQuestions = Math.min(
                Number(nextQuizParams.numberOfQuestions || maxAvailableQuestions || 1),
                Math.max(maxAvailableQuestions, 1)
            );
        }

        if (quizType === 'Both' && nextQuizParams.numberOfQuestions !== '') {
            const availableOpenQuestions = availableQuestions.filter((question) => question.questionType === 'open').length;
            nextQuizParams.numberOfOpenQuestions = nextQuizParams.numberOfOpenQuestions === ''
                ? ''
                : Math.min(
                    Number(nextQuizParams.numberOfOpenQuestions || 0),
                    availableOpenQuestions,
                    Number(nextQuizParams.numberOfQuestions || 0)
                );
        }

        setQuizParams(nextQuizParams);
        saveQuizSettingsForSubject(selectedSubject?._id, nextQuizParams);
    };

     // Funzione per convertire "HH:mm" in minuti
    const convertTimeToMinutes = (timeStr) => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        return (hours * 60) + minutes;  // Converte ore e minuti in totale minuti
    };

    // Funzione specifica per aggiornare il timer da Flatpickr
    const handleTimerChange = (selectedDates, dateStr) => {
        const timerInMinutes = convertTimeToMinutes(dateStr);  // Converti il timer in minuti
        //alert(timerInMinutes);
        if (timerInMinutes > 480) { // 480 minuti = 8 ore
            //alert("Max Timer is 8 hours!");
            timerRef.current.flatpickr.setDate("08:00", true);
            const nextQuizParams = {
                ...quizParams,
                timer: 480, // Aggiorna il timer con il valore formattato
            };

            setQuizParams(nextQuizParams);
            saveQuizSettingsForSubject(selectedSubject?._id, nextQuizParams);
            return;
        }

        const nextQuizParams = {
            ...quizParams,
            timer: timerInMinutes, // Aggiorna il timer con il valore formattato
        };

        setQuizParams(nextQuizParams);
        saveQuizSettingsForSubject(selectedSubject?._id, nextQuizParams);
    };

    const handleQuizClick = async (subject) => {
        setSelectedSubject(subject); // Salva la materia selezionata
        console.log("Subject: ", subject);
        //alert(JSON.stringify(subject.name));
        setSubjectName(subject.name);
        console.log("subject._id: ", subject._id);
        const subjectQuestions = await fetchQuestions(subject);
        const savedQuizParams = quizSettingsBySubjectId[subject._id];
        const nextQuizParams = savedQuizParams
            ? normalizeQuizParams(savedQuizParams, subjectQuestions)
            : getDefaultQuizParams(subject, subjectQuestions);

        setQuizParams(nextQuizParams);
        saveQuizSettingsForSubject(subject._id, nextQuizParams);
        handleShowQuiz(); // Mostra la modale
    };

    const [pricing, setPricing]=useState('pricing') 
    const pricingLists = [
        {
            title: 'Subject 1',
            icon:  right,
            icon1: right,
            icon2: right,
            icon3: right
        },
        {
        title: 'Subject 2',
        icon:  wrong,
        icon1: right,
        icon2: right,
        icon3: right
        },
        {
            title: 'Subject 3',
            icon: wrong,
            icon1:right,
            icon2:right,
            icon3:right
        },
        {
        title: 'Subject 4',
        icon: right,
        icon1:right,
        icon2:right,
        icon3:right
        },
        {
        title: 'Subject 5',
        icon:  wrong,
        icon1: wrong,
        icon2: right,
        icon3: right
        }
    ]

    const incompleteClosedQuestions = Array.isArray(questions)
        ? questions.filter(isClosedQuestionMissingCorrectAnswer)
        : [];
    const incompleteOpenQuestions = Array.isArray(questions)
        ? questions.filter(isOpenQuestionMissingAnswer)
        : [];
    const closedQuestionsForKeywords = Array.isArray(questions)
        ? questions.filter((question) => question.questionType === 'closed')
        : [];
    const questionsWithoutSavedKeyword = closedQuestionsForKeywords.filter((question) => (
        !getSavedKeywordHint(question)
        && !isQuestionKeywordHintDisabled(question)
    ));
    const questionsWithAutomaticKeyword = questionsWithoutSavedKeyword.filter((question) => (
        Boolean(getAutomaticKeywordHint(question, text))
    ));
    const missingKeywordQuestions = questionsWithoutSavedKeyword.filter((question) => (
        !getAutomaticKeywordHint(question, text)
    ));
    const missingKeywordQuestionsCount = missingKeywordQuestions.length;
    const unsavedKeywordQuestionsCount = questionsWithAutomaticKeyword.length;
    const keywordToolButtonCount = missingKeywordQuestionsCount + unsavedKeywordQuestionsCount;
    const hasMissingKeywordQuestions = missingKeywordQuestionsCount > 0;
    const hasUnsavedKeywordQuestions = unsavedKeywordQuestionsCount > 0;
    const hasMixedKeywordQuestions = hasMissingKeywordQuestions && hasUnsavedKeywordQuestions;
    const keywordToolTitle = hasMixedKeywordQuestions
        ? text.keywordToolsMixedTitle(missingKeywordQuestionsCount, unsavedKeywordQuestionsCount)
        : (
            hasMissingKeywordQuestions
                ? text.keywordToolsMissingTitle(missingKeywordQuestionsCount)
                : text.keywordToolsUnsavedTitle(unsavedKeywordQuestionsCount)
        );
    const keywordToolDescription = hasMixedKeywordQuestions
        ? text.keywordToolsMixedDescription(missingKeywordQuestionsCount, unsavedKeywordQuestionsCount)
        : (
            hasMissingKeywordQuestions
                ? text.keywordToolsMissingDescription(missingKeywordQuestionsCount)
                : text.keywordToolsUnsavedDescription(unsavedKeywordQuestionsCount)
        );
    const keywordToolButtonLabel = hasMixedKeywordQuestions
        ? text.keywordToolsMixedShort(missingKeywordQuestionsCount, unsavedKeywordQuestionsCount)
        : hasMissingKeywordQuestions
            ? text.keywordToolsMissingTitle(missingKeywordQuestionsCount)
            : text.unsavedKeywordsShort(unsavedKeywordQuestionsCount);
    const visibleQuestionRows = keywordTableFilter === 'missingKeywords'
        ? missingKeywordQuestions
        : keywordTableFilter === 'unsavedKeywords'
            ? questionsWithAutomaticKeyword
            : questions;

    useEffect(() => {
        if (
            (keywordTableFilter === 'missingKeywords' && missingKeywordQuestionsCount === 0)
            || (keywordTableFilter === 'unsavedKeywords' && unsavedKeywordQuestionsCount === 0)
        ) {
            setKeywordTableFilter('all');
        }
    }, [keywordTableFilter, missingKeywordQuestionsCount, unsavedKeywordQuestionsCount]);

    useEffect(() => {
        setKeywordPromptCopyMessage('');
    }, [keywordTableFilter]);

    function getQuestionsForQuizFilterByValue(filterValue = quizParams.questionFilter, sourceQuestions = questions) {
        return filterQuestionsByView(Array.isArray(sourceQuestions) ? sourceQuestions : [], filterValue);
    }
    const getQuestionsForQuizFilter = (sourceQuestions = questions) => (
        getQuestionsForQuizFilterByValue(quizParams.questionFilter, sourceQuestions)
    );
    const filteredQuizQuestions = getQuestionsForQuizFilter();
    const filteredOpenQuestions = filteredQuizQuestions.filter((question) => question.questionType === 'open');
    const filteredClosedQuestions = filteredQuizQuestions.filter((question) => question.questionType === 'closed');
    const selectedQuizType = quizParams.questionType || 'Closed';
    const typedQuestionsForFilter = getQuestionsByType(questions, selectedQuizType);
    const quizFilterAvailability = getQuestionFilterAvailability(typedQuestionsForFilter);
    const maxQuestionsForSelectedType = selectedQuizType === 'Open'
        ? filteredOpenQuestions.length
        : selectedQuizType === 'Both'
            ? filteredQuizQuestions.length
            : filteredClosedQuestions.length;
    const requestedQuestionCount = Math.min(
        Number(quizParams.numberOfQuestions || maxQuestionsForSelectedType || 1),
        Math.max(maxQuestionsForSelectedType, 1)
    );
    const maxOpenQuestionsForQuiz = selectedQuizType === 'Both'
        ? Math.min(filteredOpenQuestions.length, requestedQuestionCount)
        : filteredOpenQuestions.length;
    const availableOpenQuestionsForFilter = filteredOpenQuestions.length;
    const currentCompletionQuestion = questionsToComplete[completionQuestionIndex] || null;
    const getSubjectQuestionButtonVariant = (subject) => {
        if (!subject.totalQuestions) {
            return 'btn-danger';
        }

        if (subject.missingCorrectAnswers > 0) {
            return 'btn-warning';
        }

        return 'btn-primary';
    };

    const getSubjectQuestionBadgeCount = (subject) => (
        subject.missingCorrectAnswers > 0
            ? subject.missingCorrectAnswers
            : subject.missingOpenAnswers || 0
    );

    const getMissingAnswersSummary = (subject) => {
        const missingClosedAnswers = Number(subject.missingCorrectAnswers || 0);
        const missingOpenAnswers = Number(subject.missingOpenAnswers || 0);

        if (!missingClosedAnswers && !missingOpenAnswers) {
            return '';
        }

        return text.missingAnswersSummary(missingClosedAnswers, missingOpenAnswers);
    };

    if (showQuizScreen) {
        // Se il quiz è avviato, mostra il componente del QuizScreen
        return (
            <QuizScreen
                breakpoint={fullscreen}
                subject={{
                    ...selectedSubject,
                    archiveName: selectedArchive?.name || '',
                }}
                quizParams={quizParams}
                questions={quizQuestions.map((question) => ({
                    ...question,
                    subjectName: question.subjectName || selectedSubject?.name || '',
                    archiveName: question.archiveName || selectedArchive?.name || '',
                }))}
                setShowQuizScreen={setShowQuizScreen}
            />
        );
    }

    if (!selectedArchive) {
        return (
            <div className={`subjects-view-transition ${isArchiveSwitching ? 'is-view-switching' : ''}`}>
                {importPreloader}
                <Row>
                    <Col md="12">
                        {archivesError ? (
                            <Alert variant="danger" role="alert">
                                {archivesError}
                            </Alert>
                        ) : ""}
                        {!isArchivesLoading && archives.length === 0 ? (
                            <Alert variant="primary alert-dismissible fade show" role="alert" show={showArchiveAlert} onClose={() => setShowArchiveAlert(false)} dismissible>
                                {text.emptyArchiveAlertPrefix} <Link to="#" onClick={handleShowAddArchive} className="alert-link">{text.emptyArchiveAlertAction}</Link> {text.emptyArchiveAlertSuffix}
                            </Alert>
                        ) : ""}
                        <Row className=" row-cols-1 row-cols-md-2 row-cols-lg-4 mb-3 text-center">
                            <Col>
                                <Card className=" mb-4 rounded-3 ">
                                    <Card.Body className="add-subject-card-body">
                                        <Card.Title
                                            as="h1"
                                            className="pricing-card-title quizify-entity-card-title quizify-entity-add-title mb-3"
                                            title={text.addArchive}
                                        >
                                            {text.addArchive}
                                        </Card.Title>
                                        <div className="overlay">
                                            <button type="button" className="btn btn-soft-primary add-subjet" onClick={handleShowAddArchive}>{add}</button>
                                            <Modal className="modal-theme-bg" show={showAddArchive} onHide={handleCloseAddArchive} centered>
                                                <Form onSubmit={(e) => handleSubmitAddArchive(e)}>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title as="h5">{text.addArchive}</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <Form.Group className="form-group">
                                                            <Form.Label htmlFor="archiveName">{text.archiveName}</Form.Label>
                                                            <Form.Control type="text" ref={archiveNameRef} id="archiveName" onChange={(e) => setArchiveName(e.target.value)} required/>
                                                        </Form.Group>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button type="submit" variant="success">{text.add}</Button>
                                                        <Button variant="soft-danger" onClick={handleCloseAddArchive}>{text.close}</Button>
                                                    </Modal.Footer>
                                                </Form>
                                            </Modal>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            {isArchivesLoading ? (
                                <Col>
                                    <Card className=" mb-4 rounded-3 ">
                                        <Card.Body className="py-5 text-center">
                                            <Spinner animation="border" variant="primary" />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ) : archives.length > 0 ? (
                                archives.map((archive) => (
                                    <Col key={archive._id}>
                                        <Card className="mb-4 rounded-3 quizify-entity-card">
                                            <Card.Body>
                                                <Card.Title
                                                    as="h1"
                                                    className="pricing-card-title quizify-entity-card-title"
                                                    title={archive.name}
                                                >
                                                    {archive.name}
                                                </Card.Title>
                                                <h4 className="my-0 fw-normal mt-3"><strong>{text.totalSubjects}: {archive.totalSubjects}</strong></h4>
                                                <ul className="list-unstyled my-3 p-0">
                                                    <li><p><strong>{text.totalQuestions}:</strong> {archive.totalQuestions}</p></li>
                                                </ul>
                                                <div className="d-flex justify-content-end">
                                                    <button type="button" className="btn btn-primary btn-subjet me-2" onClick={() => handleSelectArchive(archive)}>{quest}</button>
                                                    <button type="button" className="btn btn-soft-danger btn-subjet" onClick={() => handleShowDeleteArchive(archive)}>{del}</button>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <Col>
                                    <Card className=" mb-4 rounded-3 ">
                                        <Card.Body>
                                            <Card.Title as="h3" className=" pricing-card-title">{text.noArchives}</Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                        {archiveToDelete && (
                            <Modal className="modal-theme-bg" show={!!archiveToDelete} onHide={handleCloseDeleteArchive} centered>
                                <Form onSubmit={(e) => handleConfirmDeleteArchive(e)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title as="h5">{text.confirmArchiveDeletion}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Alert variant="danger">
                                            {text.deleteArchiveWarning(archiveToDelete.name)}
                                        </Alert>
                                        <Form.Group className="form-group mb-0">
                                            <Form.Label htmlFor="archiveDeleteConfirmation">{text.deleteArchiveConfirmationLabel}</Form.Label>
                                            <Form.Control
                                                id="archiveDeleteConfirmation"
                                                type="text"
                                                value={archiveDeleteConfirmation}
                                                onChange={(e) => setArchiveDeleteConfirmation(e.target.value)}
                                                placeholder={text.deleteArchiveConfirmationPlaceholder}
                                                required
                                            />
                                        </Form.Group>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button
                                            type="submit"
                                            variant="danger"
                                            disabled={isDeletingArchive || !['ELIMINA', 'DELETE'].includes(archiveDeleteConfirmation.trim().toUpperCase())}
                                        >
                                            {isDeletingArchive ? text.deleting : text.yesDelete}
                                        </Button>
                                        <Button type="button" variant="soft-secondary" onClick={handleCloseDeleteArchive} disabled={isDeletingArchive}>{text.abort}</Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        )}
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <div className="subjects-view-transition">
            {importPreloader}
            <Row>
                <Col md="12">
                <Card className="mb-3 rounded-3">
                    <Card.Body className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 py-3">
                        <div>
                            <div className="text-muted small">{text.archive}</div>
                            <div className="fw-semibold">{selectedArchive.name}</div>
                        </div>
                        <Button type="button" variant="primary" onClick={() => {
                            setIsArchiveSwitching(false);
                            setSelectedArchive(null);
                            navigate('/archives');
                        }}>
                            {text.backToArchives}
                        </Button>
                    </Card.Body>
                </Card>
                {
                    subjectsError ? (
                    <Alert variant="danger" role="alert">
                        {subjectsError}
                    </Alert>) : ""
                }
                {
                    !isSubjectsLoading && subjects.length === 0 ? (
                    <Alert variant="primary alert-dismissible fade show" role="alert" show={showAlert1} onClose={() => setShowAlert1(false)} dismissible >
                        {text.emptyAlertPrefix} <Link to="#" onClick={handleShowAddSubject} className="alert-link">{text.emptyAlertAction}</Link> {text.emptyAlertSuffix}
                        {/* <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => showAlert1(false)}></button> */}
                     </Alert>) : ""
                }
                    <Row className=" row-cols-1 row-cols-md-2 row-cols-lg-4 mb-3 text-center">
                        <Col>
                            <Card className=" mb-4 rounded-3 ">
                                <Card.Body className="add-subject-card-body">
                                    <Card.Title
                                        as="h1"
                                        className="pricing-card-title quizify-entity-card-title quizify-entity-add-title mb-3"
                                        title={text.addSubject}
                                    >
                                        {text.addSubject}
                                    </Card.Title>
                                    <div className="overlay">
                                        <button type="button" className="btn btn-soft-primary add-subjet" onClick={handleShowAddSubject}>{add}</button>
                                        {/* <!-- Subject Modal --> */}
                                            <Modal
                                                className="modal-theme-bg import-all-pdf-modal"
                                                show={showAddSubject}
                                                onHide={handleCloseAddSubject}
                                                centered
                                                scrollable
                                                backdrop={isImportingAllPdf ? 'static' : true}
                                                keyboard={!isImportingAllPdf}
                                            >
                                                <Form className="import-all-pdf-form" onSubmit={(e) => (isAddSubjectImportMode ? handleSubmitImportAllPdf(e) : handleSubmitAddSubject(e))}>
                                                    <Modal.Header closeButton={!isImportingAllPdf}>
                                                            <Modal.Title as="h5">{isAddSubjectImportMode ? text.importAllFromPdfTitle : text.addSubject}</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body className="import-all-pdf-body">
                                                        {!isAddSubjectImportMode ? (
                                                            <div className="mb-3">
                                                                <Form.Group className="form-group">
                                                                    <Form.Label htmlFor="subjectName">{text.subjectName}</Form.Label>
                                                                    <Form.Control type="text" ref={nameRef} id="subjectName" onChange={(e) => setName(e.target.value)} aria-describedby={text.subjectName} required/>
                                                                </Form.Group >
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <Alert variant="info">
                                                                    {importAllPdfType === 'ecampus' ? text.ecampusImportText : text.mininternoImportText}
                                                                </Alert>
                                                                <Form.Group className="form-group">
                                                                    <Form.Label htmlFor="importAllPdfType">{text.importMode}</Form.Label>
                                                                    <Form.Select
                                                                        id="importAllPdfType"
                                                                        value={importAllPdfType}
                                                                        disabled={isImportingAllPdf}
                                                                        onChange={(e) => {
                                                                            setImportAllPdfType(e.target.value);
                                                                            setImportAllReport(null);
                                                                        }}
                                                                    >
                                                                        <option value="ecampus">{text.ecampusFullImport}</option>
                                                                        <option value="mininterno">{text.mininternoFullImport}</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Label htmlFor="importAllPdfFile">{text.fullPdfFile}</Form.Label>
                                                                    <Form.Control
                                                                        type="file"
                                                                        id="importAllPdfFile"
                                                                        accept="application/pdf"
                                                                        disabled={isImportingAllPdf}
                                                                        onChange={(e) => {
                                                                            setImportAllPdfFile(e.target.files?.[0] || null);
                                                                            setImportAllReport(null);
                                                                        }}
                                                                    />
                                                                    {importAllPdfFile && (
                                                                        <small className="text-muted d-block mt-2">
                                                                            {importAllPdfFile.name}
                                                                        </small>
                                                                    )}
                                                                </Form.Group>
                                                                {importAllReport && (
                                                                    <Alert variant="success" className="mt-3 mb-0">
                                                                        <h6 className="mb-2">{text.importReport}</h6>
                                                                        <p className="mb-1"><strong>{text.subjectName}:</strong> {importAllReport.subjectName}</p>
                                                                        {importAllReport.subjectsCount ? (
                                                                            <p className="mb-1">{text.importedSubjects(importAllReport.subjectsCount)}</p>
                                                                        ) : null}
                                                                        {importAllReport.importType !== 'mininterno' && (
                                                                            <p className="mb-1">{text.expectedQuestions(importAllReport.expected?.open, importAllReport.expected?.closed, importAllReport.expected?.total)}</p>
                                                                        )}
                                                                        {importAllReport.expected?.total && importAllReport.contentQuestionMarkers !== undefined && importAllReport.contentQuestionMarkers !== importAllReport.expected.total && (
                                                                            <p className="mb-1">{text.contentQuestionMarkers(importAllReport.contentQuestionMarkers)}</p>
                                                                        )}
                                                                        <p className="mb-1">{text.detectedQuestions(importAllReport.detected?.open, importAllReport.detected?.closed, importAllReport.detected?.total)}</p>
                                                                        <p className="mb-1">{text.importedQuestions(importAllReport.imported?.open, importAllReport.imported?.closed, importAllReport.imported?.total)}</p>
                                                                        {importAllReport.answerSummary && (
                                                                            <>
                                                                                <p className="mb-1">{text.detectedAnsweredQuestions(importAllReport.answerSummary.detected)}</p>
                                                                                <p className="mb-1">{text.insertedAnsweredQuestions(importAllReport.answerSummary.inserted)}</p>
                                                                                <p className="mb-1">{text.updatedAnsweredQuestions(importAllReport.answerSummary.updated)}</p>
                                                                                <p className="mb-1">{text.finalAnsweredQuestions(importAllReport.answerSummary.final)}</p>
                                                                            </>
                                                                        )}
                                                                        <p className="mb-1">{text.skippedDuplicates(importAllReport.skippedDuplicates || 0)}</p>
                                                                        {Number(importAllReport.updatedDuplicateCorrectAnswers || 0) > 0 && (
                                                                            <p className="mb-1">{text.updatedDuplicateCorrectAnswers(importAllReport.updatedDuplicateCorrectAnswers || 0)}</p>
                                                                        )}
                                                                        {Number(importAllReport.updatedDuplicateOpenAnswers || 0) > 0 && (
                                                                            <p className="mb-1">{text.updatedDuplicateOpenAnswers(importAllReport.updatedDuplicateOpenAnswers || 0)}</p>
                                                                        )}
                                                                        {Number(importAllReport.updatedDuplicateKeywordHints || 0) > 0 && (
                                                                            <p className="mb-1">{text.updatedDuplicateKeywordHints(importAllReport.updatedDuplicateKeywordHints || 0)}</p>
                                                                        )}
                                                                        {Number(importAllReport.keywordHintsSaved || importAllReport.keywordHintsCreated || importAllReport.updatedDuplicateKeywordHints || 0) > 0 && (
                                                                            <>
                                                                                <p className="mb-1">{text.keywordHintsSavedDuringImport(importAllReport.keywordHintsCreated || 0, importAllReport.updatedDuplicateKeywordHints || 0)}</p>
                                                                                <p className="mb-1">{text.keywordHintsImportSources(importAllReport.keywordHintsFromPdf || 0, importAllReport.keywordHintsGenerated || 0)}</p>
                                                                            </>
                                                                        )}
                                                                        {text.keywordHighlightSignalsSummary(importAllReport.parserSignals) && (
                                                                            <p className="mb-1">{text.keywordHighlightSignalsSummary(importAllReport.parserSignals)}</p>
                                                                        )}
                                                                        {(importAllReport.duplicateDetails || []).length > 0 && (
                                                                            <div className="mt-2 mb-2">
                                                                                <div className="fw-semibold">{text.duplicateDetailsTitle}</div>
                                                                                <div className="small overflow-auto" style={{ maxHeight: '140px' }}>
                                                                                    {importAllReport.duplicateDetails.map((duplicateDetail, index) => (
                                                                                        <div key={`${duplicateDetail.subjectName || 'subject'}-${duplicateDetail.pdfQuestionNumber}-${duplicateDetail.existingQuestionNumber}-${index}`}>
                                                                                            {text.duplicateDetail(duplicateDetail)}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {importAllReport.passages ? (
                                                                            <p className="mb-1">{text.detectedPassages(importAllReport.passages)}</p>
                                                                        ) : null}
                                                                        {(importAllReport.warnings || []).length > 0 && (
                                                                            <div className="mt-2 mb-2">
                                                                                <div className="fw-semibold">{text.importWarningsTitle}</div>
                                                                                <div className="small overflow-auto" style={{ maxHeight: '120px' }}>
                                                                                    {importAllReport.warnings.map((warning, index) => (
                                                                                        <div key={`${warning.subjectId || 'subject'}-${warning.sourceQuestionNumber || index}-${index}`}>
                                                                                            {warning.subjectName ? `${warning.subjectName}: ` : ''}{warning.message || warning}
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        <p className="mb-1">{text.missingCorrectAnswers(importAllReport.missingCorrectAnswers || 0)}</p>
                                                                        <p className="mb-0">{text.missingOpenAnswers(importAllReport.missingOpenAnswers || 0)}</p>
                                                                    </Alert>
                                                                )}
                                                            </>
                                                        )}
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        {!isAddSubjectImportMode ? (
                                                            <>
                                                                <Button type="button" variant="primary" onClick={() => setIsAddSubjectImportMode(true)}>{text.importFromPdf}</Button>
                                                                <Button type="submit" variant="success">{text.add}</Button>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Button type="submit" variant="primary" disabled={isImportingAllPdf || !importAllPdfFile}>
                                                                    {isImportingAllPdf ? text.importing : text.importPdf}
                                                                </Button>
                                                                <Button type="button" variant="soft-secondary" onClick={() => setIsAddSubjectImportMode(false)} disabled={isImportingAllPdf}>{text.backToAddSubject}</Button>
                                                            </>
                                                        )}
                                                        <Button variant="soft-danger" onClick={handleCloseAddSubject} disabled={isImportingAllPdf}>{text.close}</Button>
                                                    </Modal.Footer>
                                                </Form>
                                            </Modal>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        {
                            isSubjectsLoading ? (
                                <Col>
                                    <Card className=" mb-4 rounded-3 ">
                                        <Card.Body className="py-5 text-center">
                                            <Spinner animation="border" variant="primary" />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ) : subjects.length > 0 ? (
                                  subjects.map(subject => (
                                    <Col key={subject._id}>
                                        <Card className="mb-4 rounded-3 quizify-entity-card">
                                            <Card.Body>
                                                <Card.Title
                                                    as="h1"
                                                    className="pricing-card-title quizify-entity-card-title"
                                                    title={subject.name}
                                                >
                                                    {subject.name}
                                                </Card.Title>
                                                <h4 className="my-0 fw-normal mt-3"><strong>{text.totalQuestions}: {subject.totalQuestions}</strong></h4>
                                                <ul className="list-unstyled my-3 p-0">
                                                    <li><p><strong>{text.closedQuestions}:</strong> {subject.closedQuestions}</p></li>
                                                    <li><p><strong>{text.openQuestions}:</strong> {subject.openQuestions}</p></li>
                                                    {getMissingAnswersSummary(subject) && (
                                                        <li><p className="text-warning"><strong>{getMissingAnswersSummary(subject)}</strong></p></li>
                                                    )}
                                                </ul>
                                                <div className="d-flex justify-content-end">
                                                    {subject.totalQuestions >=2 ? (
                                                        <button type="button" className="btn btn-soft-success btn-subjet me-2" onClick={() => handleQuizClick(subject)}>{quiz}</button>  
                                                        ) : (<button type="button" className="btn btn-soft-success btn-subjet me-2" disabled>{quiz}</button>  )}
                                                     
                                                    {values.map((v, idx) => (
                                                        <button
                                                            key={idx}
                                                            className={`btn ${getSubjectQuestionButtonVariant(subject)} btn-subjet me-2 position-relative`}
                                                            title={!subject.totalQuestions ? text.noQuestionsButtonTitle : (subject.missingCorrectAnswers > 0 ? text.missingAnswersButtonTitle(subject.missingCorrectAnswers) : (subject.missingOpenAnswers > 0 ? text.missingOpenAnswersButtonTitle(subject.missingOpenAnswers) : text.questions))}
                                                            onClick={() => handleQuestionClick(v, subject)}
                                                        >
                                                            {quest}
                                                            {getSubjectQuestionBadgeCount(subject) > 0 && (
                                                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark">
                                                                    {getSubjectQuestionBadgeCount(subject)}
                                                                </span>
                                                            )}
                                                            {typeof v === 'string' && `below ${v.split('-')[0]}`}
                                                        </button>
                                                    ))}
                                                    <button type="button" onClick={() => handleEditClick(subject)} className="btn btn-soft-warning btn-subjet me-2">{edit}</button>
                                                    <button onClick={() => handleDeleteClick(subject)} type="button" className="btn btn-soft-danger btn-subjet">{del}</button>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                 ))
                              ) : (
                                <Col>
                                    <Card className=" mb-4 rounded-3 ">
                                        <Card.Body>
                                            <Card.Title as="h3" className=" pricing-card-title">{text.noSubjects}</Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Col>
                              )
                        }
                        {/* <!-- Start Quiz Modal --> */}
                        {showModalQuiz && selectedSubject && questions && (
                        <Modal className="modal-theme-bg quiz-settings-modal" show={showModalQuiz} onHide={handleCloseQuiz} centered>
                            <Form onSubmit={handleSubmitQuiz}>
                                <Modal.Header closeButton>
                                    <div>
                                        <h5>{text.settingQuiz}</h5>
                                        <small className="text-muted ">
                                            {selectedSubject.name}
                                        </small>
                                    </div>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="mb-3">
                                        <Row>
                                            <Col md="6">
                                                <Form.Group className="form-group">
                                                    <InputGroup className="quiz-settings-input-group">
                                                        <span className="input-group-text">
                                                            {text.numberAllQuestions}
                                                        </span>
                                                        <input
                                                            name="numberOfQuestions"
                                                            type="number"
                                                            className="form-control quiz-settings-number-input"
                                                            aria-label={text.numberAllQuestions}
                                                            value={quizParams.numberOfQuestions || ''}
                                                            min="1"
                                                            max={Math.max(maxQuestionsForSelectedType, 1)}
                                                            onChange={handleChangeQuizParams}
                                                            required
                                                        />
                                                    </InputGroup>
                                                    <small className="text-muted d-block mt-1">
                                                        {text.availableQuestions(maxQuestionsForSelectedType)}
                                                    </small>
                                                </Form.Group>
                                            </Col>
                                            <Col md="6">
                                                <Form.Group className="form-group">
                                                    <InputGroup>
                                                        <span className="input-group-text">{text.timer}</span>
                                                        <Flatpickr ref={timerRef} onChange={handleTimerChange} options={{
                                                            enableTime: true,noCalendar: true, time_24hr: true, dateFormat: "H:i", defaultDate: "00:00",
                                                            defaultHour: 0, defaultMinute: 30, minuteIncrement: 5, 
                                                            minTime: "00:00", maxTime: "08:00",}} 
                                                            placeholder={text.timerPlaceholder} className="form-control time_flatpicker "/>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md="12">
                                                <Form.Group className="form-group">
                                                    <InputGroup>
                                                        <span className="input-group-text">{text.quizType}</span>
                                                        <Form.Select className="form-select" name="questionType" value={quizParams.questionType || 'Closed'} onChange={handleChangeQuizParams}>
                                                            <option value='Closed'>{text.closed}</option>
                                                            {selectedSubject.openQuestions > 0 && (
                                                                <>
                                                                    <option value='Open'>{text.open}</option>
                                                                    <option value='Both'>{text.both}</option>
                                                                </>
                                                            )}
                                                            
                                                        </Form.Select>
                                                    </InputGroup>
                                                </Form.Group>
                                                
                                            </Col>
                                            {quizParams.questionType === "Both" && (
                                            <Col md="12">
                                                <Form.Group className="form-group">
                                                    <InputGroup className="quiz-settings-input-group">
                                                        <span className="input-group-text">
                                                            {text.numberOpenQuestions}
                                                        </span>
                                                        <input
                                                            type="number"
                                                            name="numberOfOpenQuestions"
                                                            className="form-control quiz-settings-number-input"
                                                            aria-label={text.numberOpenQuestions}
                                                            min="0"
                                                            max={Math.max(maxOpenQuestionsForQuiz, 0)}
                                                            value={quizParams.numberOfOpenQuestions || 0}
                                                            onChange={handleChangeQuizParams}
                                                            required
                                                        />
                                                    </InputGroup>
                                                    <small className="text-muted d-block mt-1">
                                                        {text.availableOpenQuestions(availableOpenQuestionsForFilter)}
                                                    </small>
                                                </Form.Group>
                                            </Col>
                                            )}
                                            <Col md="12">
                                                <Form.Group className="form-group">
                                                    <InputGroup>
                                                        <span className="input-group-text">{text.questionOrder}</span>
                                                        <Form.Select className="form-select" name="questionOrder" value={quizParams.questionOrder || 'inserted'} onChange={handleChangeQuizParams}>
                                                            <option value="inserted">{text.insertedOrder}</option>
                                                            <option value="random">{text.randomOrder}</option>
                                                        </Form.Select>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md="12">
                                                <Form.Group className="form-group">
                                                    <InputGroup>
                                                        <span className="input-group-text">{text.answerOrder}</span>
                                                        <Form.Select className="form-select" name="answerOrder" value={quizParams.answerOrder || 'inserted'} onChange={handleChangeQuizParams}>
                                                            <option value="inserted">{text.answerInsertedOrder}</option>
                                                            <option value="random">{text.answerRandomOrder}</option>
                                                            <option value="correctFirst">{text.correctAnswerFirst}</option>
                                                        </Form.Select>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            <Col md="12">
                                                <Form.Group className="form-group">
                                                    <InputGroup>
                                                        <span className="input-group-text">{text.questionFilter}</span>
                                                        <Form.Select className="form-select" name="questionFilter" value={quizParams.questionFilter || 'all'} onChange={handleChangeQuizParams}>
                                                            <option value="unseen" disabled={!quizFilterAvailability.unseen}>
                                                                {text.filterQuestionCount(text.onlyUnseenQuestions, quizFilterAvailability.unseen)}
                                                            </option>
                                                            <option value="seen" disabled={!quizFilterAvailability.seen}>
                                                                {text.filterQuestionCount(text.onlySeenQuestions, quizFilterAvailability.seen)}
                                                            </option>
                                                            <option value="all" disabled={!quizFilterAvailability.all}>
                                                                {text.filterQuestionCount(text.allSeenAndUnseenQuestions, quizFilterAvailability.all)}
                                                            </option>
                                                            <option value="progressive" disabled={!quizFilterAvailability.progressive}>
                                                                {text.filterQuestionCount(text.progressiveReview, quizFilterAvailability.progressive)}
                                                            </option>
                                                        </Form.Select>
                                                    </InputGroup>
                                                </Form.Group>
                                            </Col>
                                            {['Open', 'Both'].includes(quizParams.questionType) && (
                                                <Col md="12">
                                                    <Form.Group className="form-group">
                                                        <Form.Check
                                                            type="switch"
                                                            id="subject-quiz-auto-open-answers"
                                                            name="autoShowOpenAnswers"
                                                            label={text.automaticOpenAnswers}
                                                            checked={quizParams.autoShowOpenAnswers === true}
                                                            onChange={handleChangeQuizParams}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            <Col md="12">
                                                <Form.Group className="form-group">
                                                    <Form.Check
                                                        type="switch"
                                                        id="subject-quiz-show-keywords"
                                                        name="showKeywords"
                                                        label={text.showKeywords}
                                                        checked={quizParams.showKeywords !== false}
                                                        onChange={handleChangeQuizParams}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="submit" variant="success">{text.start}</Button>
                                    <Button variant="soft-danger" onClick={handleCloseQuiz}>{text.close}</Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                        )}
                        {/* <!-- Add Question & Answer Modal --> */}
                        {showModalAddQuestion && selectedSubject && (
                        <Modal className="modal-question-bg" show={showModalAddQuestion} onHide={handleCloseAddQuestion} centered>
                            <Form onSubmit={(e) => handleSubmitAddQuestion(e)}>
                                <Modal.Header closeButton>
                                    <div>
                                        <h5>{text.addQuestionAnswers}</h5>
                                        <small className="text-muted ">
                                            {selectedSubject.name}
                                        </small>
                                    </div>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="mb-3">
                                        <Form.Group className="form-group">
                                            <span className="input-group-text">{text.question}</span>
                                            <InputGroup>
                                                <textarea ref={questionToAddRef} rows={3} className="form-control" onChange={(e) => setQuestionToAdd(e.target.value)} aria-label={text.question} required></textarea>
                                            </InputGroup>
                                        </Form.Group>
                                        
                                        <div className="text-center mb-1">{text.questionAnswerType}</div>
                                        <div className="d-flex align-items-center justify-content-center mb-3">
                                            <Badge bg="secondary me-2">{text.closed}</Badge>
                                            <Form.Check className="form-switch">
                                                <FormCheck.Input className="form-check-input-question-type primary" onChange={(e) => setOpenedQuestion(!isOpenedQuestion)} type="checkbox" id="flexSwitchCheckChecked" />
                                            </Form.Check>
                                            <Badge bg="primary" className='me-3'>{text.open}</Badge>
                                            <Badge bg="secondary" className='me-2'>{text.single}</Badge>
                                            <Form.Check className="form-switch">
                                                <FormCheck.Input ref={isMultipleRef} className="form-check-input-question-type primary" onChange={(e) => setIsMultiple(!isMultiple)} type="checkbox" id="flexSwitchCheckChecked" />
                                            </Form.Check>
                                            <Badge bg="primary" className=''>{text.multiple}</Badge>
                                        </div>
                                        {answersToAdd.map((answer, index) => (
                                             
                                            (isOpenedQuestion && (
                                                    
                                             
                                            <Form.Group key={index} className="form-group">
                                                <InputGroup>
                                                    <span className="input-group-text">
                                                        {text.correctAnswer}
                                                    </span>
                                                    <textarea rows={3} onChange={(e) => handleSetAnswers(index, 'text', e.target.value)} className="form-control" aria-label={text.correctAnswer} required></textarea>
                                                </InputGroup>
                                            </Form.Group>
                                            )) ||

                                            (!isOpenedQuestion && (
                                                    
                                             
                                                <Form.Group key={index} className="form-group">
                                                    <InputGroup> 
                                                        <span className={`input-group-text cursor-click ${answersToAdd[index].isCorrect ? 'bg-success text-white' : ''}`} onClick={(e) => handleSetCheckAnswers(index)}>
                                                             {text.answer(index + 1)}
                                                        </span>
                                                        <textarea rows={1} onChange={(e) => handleSetAnswers(index, 'text', e.target.value)} className="form-control" aria-label={text.answer(index + 1)} required></textarea>
                                                    </InputGroup>
                                                </Form.Group>
                                                ) )
                                        ))}
                                        {/*}
                                        <Form.Group className="form-group">
                                            <InputGroup>
                                            <Form.Check className="input-group-text cursor-click">Answer 1</Form.Check>
                                                <textarea rows={1} className="form-control" aria-label="Answer 1"></textarea>
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group className="form-group">
                                            <InputGroup>
                                            <Form.Check className="input-group-text cursor-click">Answer 2</Form.Check>
                                                <textarea rows={1} className="form-control" aria-label="Answer 2"></textarea>
                                            </InputGroup>
                                        </Form.Group>
                                        {*/}
                                            {!isOpenedQuestion && (
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <Button className="p-1" variant="soft-gray" size="sm" onClick={handleAddFieldAnswer} >
                                                        {add3}
                                                    </Button>
                                                    {answersToAdd.length > 2 && (
                                                        <Button className="p-1 ms-2" variant="soft-danger" size="sm" onClick={handleDelFieldAnswer} >
                                                            {del3}
                                                        </Button>

                                                    )}
                                                </div>
                                            )}
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="submit" variant="success">{text.add}</Button>
                                    <Button variant="soft-danger" onClick={handleCloseAddQuestion}>{text.close}</Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                        )}
                        {/* <!-- Questions Modal --> */}
                        {showModalQuestion && questions && ( <Modal className="modal-theme-bg" scrollable={true} show={showModalQuestion} fullscreen={fullscreen} onHide={handleCloseQuestion}>
                                <Modal.Header closeButton>
                                    <div>
                                        <h3>{text.questions}</h3>
                                        <small className="text-muted ">
                                            {subjectName}
                                        </small>
                                    </div>
                                    {/*}<Modal.Title id="modal-quest-title">{subjectName} Questions</Modal.Title>{*/}
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="d-flex flex-wrap align-items-center mb-2">
                                        <Button className="me-2 mb-2" variant="soft-success" size="sm" onClick={handleShowAddQuestion}>
                                            {add2} {text.questionAnswers}
                                        </Button>
                                        {canImportQuestionBankPdf && (
                                            <Button className="me-2 mb-2" variant="primary" size="sm" onClick={handleShowImportQuestions}>
                                                {uploadPdf} {text.importFromPdf}
                                            </Button>
                                        )}
                                        {incompleteClosedQuestions.length > 0 && (
                                            <Button className="me-2 mb-2" variant="warning" size="sm" onClick={() => handleShowCompleteAnswers(incompleteClosedQuestions)}>
                                                {text.completeClosedAnswers} ({incompleteClosedQuestions.length})
                                            </Button>
                                        )}
                                        {incompleteOpenQuestions.length > 0 && (
                                            <Button className="me-2 mb-2" variant="warning" size="sm" onClick={() => handleShowCompleteAnswers(incompleteOpenQuestions, 'open')}>
                                                {text.completeOpenQuestionsWithoutAnswers} ({incompleteOpenQuestions.length})
                                            </Button>
                                        )}
                                        {keywordToolButtonCount > 0 && (
                                            <Button
                                                className="me-2 mb-2 questions-keyword-regenerate-btn"
                                                variant={missingKeywordQuestionsCount > 0 ? 'outline-warning' : 'outline-info'}
                                                size="sm"
                                                title={keywordToolTitle}
                                                onClick={handleShowKeywordTools}
                                                disabled={isRegeneratingKeywords}
                                            >
                                                {isRegeneratingKeywords
                                                    ? text.savingKeywords
                                                    : keywordToolButtonLabel}
                                            </Button>
                                        )}
                                    </div>
                                    {keywordTableFilter !== 'all' && (
                                        <Alert variant="info" className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-2 mb-3">
                                            <span>
                                                <span>
                                                    {keywordTableFilter === 'missingKeywords'
                                                        ? text.missingKeywordFilterActive(missingKeywordQuestions.length)
                                                        : text.unsavedKeywordFilterActive(questionsWithAutomaticKeyword.length)}
                                                </span>
                                                {keywordPromptCopyMessage && (
                                                    <span className="d-block small mt-1">{keywordPromptCopyMessage}</span>
                                                )}
                                            </span>
                                            <div className="d-flex flex-wrap gap-2">
                                                {missingKeywordQuestionsCount > 0 && (
                                                    <Button
                                                        type="button"
                                                        variant="outline-warning"
                                                        size="sm"
                                                        onClick={(event) => handleCopyKeywordPrompt(event, 'missingKeywords')}
                                                    >
                                                        {text.copyMissingKeywordPrompt}
                                                    </Button>
                                                )}
                                                {unsavedKeywordQuestionsCount > 0 && (
                                                    <Button
                                                        type="button"
                                                        variant="outline-info"
                                                        size="sm"
                                                        onClick={(event) => handleCopyKeywordPrompt(event, 'unsavedKeywords')}
                                                    >
                                                        {text.copyUnsavedKeywordPrompt}
                                                    </Button>
                                                )}
                                                <Button type="button" variant="soft-info" size="sm" onClick={handleShowAllKeywordQuestions}>
                                                    {text.showAllQuestions}
                                                </Button>
                                            </div>
                                        </Alert>
                                    )}
                                    {keywordRegenerationReport && (
                                        <Alert
                                            variant={keywordRegenerationReport.updated > 0 ? 'success' : 'info'}
                                            className="mb-3"
                                            dismissible
                                            onClose={() => setKeywordRegenerationReport(null)}
                                        >
                                            {text.keywordSaveSummary(keywordRegenerationReport)}
                                        </Alert>
                                    )}
                                    <QuestionsTable selectedSubject={selectedSubject} questions={visibleQuestionRows} setSubjects={setSubjects} setQuestions={setQuestions} />
                                </Modal.Body>
                            </Modal>
                        )}
                        <Modal className="modal-theme-bg" show={showKeywordTools} onHide={handleCloseKeywordTools} centered>
                            <Modal.Header closeButton>
                                <Modal.Title as="h5">{keywordToolTitle}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p className="keyword-tools-message mb-0">{keywordToolDescription}</p>
                            </Modal.Body>
                            <Modal.Footer className="keyword-tools-footer">
                                <div className="keyword-tools-actions">
                                    {hasUnsavedKeywordQuestions && (
                                        <Button
                                            type="button"
                                            variant="primary"
                                            onClick={handleSaveAvailableKeywords}
                                            disabled={isRegeneratingKeywords || unsavedKeywordQuestionsCount === 0}
                                        >
                                            {isRegeneratingKeywords ? text.savingKeywords : text.saveAvailableKeywords}
                                        </Button>
                                    )}
                                    {hasMissingKeywordQuestions && (
                                        <Button
                                            type="button"
                                            variant="outline-warning"
                                            onClick={(event) => handleShowKeywordToolQuestions('missingKeywords', event)}
                                        >
                                            {text.showMissingKeywordQuestions}
                                        </Button>
                                    )}
                                    {hasUnsavedKeywordQuestions && (
                                        <Button
                                            type="button"
                                            variant="outline-info"
                                            onClick={(event) => handleShowKeywordToolQuestions('unsavedKeywords', event)}
                                        >
                                            {hasMixedKeywordQuestions ? text.showUnsavedKeywordQuestions : text.showKeywordToolQuestions}
                                        </Button>
                                    )}
                                </div>
                                <Button type="button" variant="soft-danger" className="keyword-tools-close" onClick={handleCloseKeywordTools}>
                                    {text.close}
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        {/* <!-- Import Questions PDF Modal --> */}
                        {showImportQuestions && selectedSubject && (
                        <Modal
                            className="modal-theme-bg"
                            show={showImportQuestions}
                            onHide={handleCloseImportQuestions}
                            centered
                            backdrop={isImportingQuestions ? 'static' : true}
                            keyboard={!isImportingQuestions}
                        >
                            <Form onSubmit={(e) => handleSubmitImportQuestions(e)}>
                                <Modal.Header closeButton={!isImportingQuestions}>
                                    <div>
                                        <h5>{text.importQuestionsFromPdf}</h5>
                                        <small className="text-muted ">
                                            {selectedSubject.name}
                                        </small>
                                    </div>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form.Group className="form-group mb-3">
                                        <Form.Label htmlFor="questionBankType">{text.questionBankType}</Form.Label>
                                        <Form.Select id="questionBankType" value="ecampus" disabled>
                                            <option value="ecampus">{text.ecampusQuestionBank}</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="form-group mb-3">
                                        <Form.Label htmlFor="questionPdf">{text.pdfFile}</Form.Label>
                                        <Form.Control
                                            id="questionPdf"
                                            type="file"
                                            accept="application/pdf,.pdf"
                                            disabled={isImportingQuestions}
                                            onChange={(e) => setImportPdfFile(e.target.files?.[0] || null)}
                                            required
                                        />
                                    </Form.Group>

                                    {importReport && (
                                        <Alert
                                            variant={
                                                importReport.expected?.total
                                                && importReport.expected.total !== importReport.detected?.total
                                                    ? 'warning'
                                                    : 'success'
                                            }
                                            className="mb-0"
                                        >
                                            <div className="fw-semibold mb-2">{text.importReport}</div>
                                            <div>{text.expectedQuestions(importReport.expected?.open, importReport.expected?.closed, importReport.expected?.total)}</div>
                                            {importReport.expected?.total && importReport.contentQuestionMarkers !== undefined && importReport.contentQuestionMarkers !== importReport.expected.total && (
                                                <div>{text.contentQuestionMarkers(importReport.contentQuestionMarkers)}</div>
                                            )}
                                            <div>{text.detectedQuestions(importReport.detected?.open, importReport.detected?.closed, importReport.detected?.total)}</div>
                                            <div>{text.importedQuestions(importReport.imported?.open, importReport.imported?.closed, importReport.imported?.total)}</div>
                                            {importReport.answerSummary && (
                                                <>
                                                    <div>{text.detectedAnsweredQuestions(importReport.answerSummary.detected)}</div>
                                                    <div>{text.insertedAnsweredQuestions(importReport.answerSummary.inserted)}</div>
                                                    <div>{text.updatedAnsweredQuestions(importReport.answerSummary.updated)}</div>
                                                    <div>{text.finalAnsweredQuestions(importReport.answerSummary.final)}</div>
                                                </>
                                            )}
                                            <div>{text.skippedDuplicates(importReport.skippedDuplicates || 0)}</div>
                                            {Number(importReport.updatedDuplicateCorrectAnswers || 0) > 0 && (
                                                <div>{text.updatedDuplicateCorrectAnswers(importReport.updatedDuplicateCorrectAnswers || 0)}</div>
                                            )}
                                            {Number(importReport.updatedDuplicateOpenAnswers || 0) > 0 && (
                                                <div>{text.updatedDuplicateOpenAnswers(importReport.updatedDuplicateOpenAnswers || 0)}</div>
                                            )}
                                            {Number(importReport.updatedDuplicateKeywordHints || 0) > 0 && (
                                                <div>{text.updatedDuplicateKeywordHints(importReport.updatedDuplicateKeywordHints || 0)}</div>
                                            )}
                                            {Number(importReport.keywordHintsSaved || importReport.keywordHintsCreated || importReport.updatedDuplicateKeywordHints || 0) > 0 && (
                                                <>
                                                    <div>{text.keywordHintsSavedDuringImport(importReport.keywordHintsCreated || 0, importReport.updatedDuplicateKeywordHints || 0)}</div>
                                                    <div>{text.keywordHintsImportSources(importReport.keywordHintsFromPdf || 0, importReport.keywordHintsGenerated || 0)}</div>
                                                </>
                                            )}
                                            {text.keywordHighlightSignalsSummary(importReport.parserSignals) && (
                                                <div>{text.keywordHighlightSignalsSummary(importReport.parserSignals)}</div>
                                            )}
                                            {(importReport.duplicateDetails || []).length > 0 && (
                                                <div className="mt-2">
                                                    <div className="fw-semibold">{text.duplicateDetailsTitle}</div>
                                                    <div className="small overflow-auto" style={{ maxHeight: '140px' }}>
                                                        {importReport.duplicateDetails.map((duplicateDetail, index) => (
                                                            <div key={`${duplicateDetail.pdfQuestionNumber}-${duplicateDetail.existingQuestionNumber}-${index}`}>
                                                                {text.duplicateDetail(duplicateDetail)}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            {(importReport.warnings || []).length > 0 && (
                                                <div className="mt-2">
                                                    <div className="fw-semibold">{text.importWarningsTitle}</div>
                                                    <div className="small overflow-auto" style={{ maxHeight: '120px' }}>
                                                        {importReport.warnings.map((warning, index) => (
                                                            <div key={`${warning.sourceQuestionNumber || index}-${index}`}>
                                                                {warning.message || warning}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            <div>{text.missingCorrectAnswers(importReport.missingCorrectAnswers || 0)}</div>
                                            <div>{text.missingOpenAnswers(importReport.missingOpenAnswers || 0)}</div>
                                        </Alert>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="submit" variant="primary" disabled={isImportingQuestions}>
                                        {isImportingQuestions ? text.importing : text.importPdf}
                                    </Button>
                                    <Button type="button" variant="soft-danger" onClick={handleCloseImportQuestions} disabled={isImportingQuestions}>{text.close}</Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                        )}
                        {/* <!-- Complete Missing Answers Modal --> */}
                        {showCompleteAnswers && (
                        <Modal
                            className="modal-theme-bg complete-answers-modal"
                            dialogClassName="complete-answers-dialog"
                            show={showCompleteAnswers}
                            onHide={handleRequestCloseCompleteAnswers}
                            backdrop="static"
                            keyboard={false}
                            centered
                            size="lg"
                            scrollable
                        >
                            <Form className="complete-answers-form" onSubmit={(e) => handleSubmitCompleteAnswers(e)}>
                                <Modal.Header>
                                    <div>
                                        <h5>{completionMode === 'open' ? text.completeMissingOpenAnswersTitle : text.completeMissingAnswersTitle}</h5>
                                        <small className="text-muted ">
                                            {selectedSubject?.name || subjectName}
                                        </small>
                                    </div>
                                </Modal.Header>
                                <Modal.Body className="complete-answers-body">
                                    <p className="mb-3">{completionMode === 'open' ? text.completeMissingOpenAnswersText : text.completeMissingAnswersText}</p>
                                    {questionsToComplete.length === 0 ? (
                                        <Alert variant="success">{completionMode === 'open' ? text.noOpenAnswersToComplete : text.noAnswersToComplete}</Alert>
                                    ) : currentCompletionQuestion && (
                                        <>
                                            <div className="complete-answers-progress d-flex justify-content-between align-items-center mb-3">
                                                <Badge bg="primary">
                                                    {completionQuestionIndex + 1}/{questionsToComplete.length}
                                                </Badge>
                                                <small className="text-muted">
                                                    {completionMode === 'open'
                                                        ? text.openAnswersFilled(Object.values(completionAnswers).filter((answer) => String(answer || '').trim()).length, questionsToComplete.length)
                                                        : text.correctAnswersSelected(Object.values(completionAnswers).filter((answers) => answers.length).length, questionsToComplete.length)}
                                                </small>
                                            </div>
                                            <Card className="complete-answers-card mb-0">
                                                <Card.Body>
                                                    <div className="complete-answers-question fw-semibold mb-3">
                                                        {currentCompletionQuestion.questionText}
                                                    </div>
                                                    {currentCompletionQuestion.passageText && (
                                                        <Button
                                                            type="button"
                                                            variant="soft-info"
                                                            size="sm"
                                                            className="mb-3"
                                                            onClick={() => setSelectedPassage(currentCompletionQuestion)}
                                                        >
                                                            {text.readPassage(currentCompletionQuestion.passageNumber)}
                                                        </Button>
                                                    )}
                                                    {completionMode === 'open' ? (
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={5}
                                                            value={completionAnswers[currentCompletionQuestion._id] || ''}
                                                            placeholder={text.openAnswerPlaceholder}
                                                            onChange={(event) => handleSetOpenCompletionAnswer(currentCompletionQuestion, event.target.value)}
                                                        />
                                                    ) : (
                                                        (currentCompletionQuestion.answers || []).map((answer, answerIndex) => (
                                                            <Form.Check
                                                                key={`${currentCompletionQuestion._id}-${answerIndex}`}
                                                                className="complete-answers-option mb-2"
                                                                type={currentCompletionQuestion.answerType === 'multiple' ? 'checkbox' : 'radio'}
                                                                name={`complete-answer-${currentCompletionQuestion._id}`}
                                                                id={`complete-answer-${currentCompletionQuestion._id}-${answerIndex}`}
                                                                label={answer.text}
                                                                checked={(completionAnswers[currentCompletionQuestion._id] || []).includes(answerIndex)}
                                                                onChange={() => handleSetCompletionAnswer(currentCompletionQuestion, answerIndex)}
                                                            />
                                                        ))
                                                    )}
                                                </Card.Body>
                                            </Card>
                                        </>
                                    )}
                                </Modal.Body>
                                <Modal.Footer className="complete-answers-footer">
                                    {showCompleteCloseConfirm && (
                                        <Alert variant="warning" className="complete-answers-unsaved-alert">
                                            <div className="fw-semibold mb-1">{text.unsavedCompleteAnswersTitle}</div>
                                            <div>{text.unsavedCompleteAnswersText}</div>
                                        </Alert>
                                    )}
                                    <div className="complete-answers-footer-nav">
                                        <Button
                                            type="button"
                                            variant="outline-primary"
                                            disabled={completionQuestionIndex === 0}
                                            onClick={() => setCompletionQuestionIndex((index) => Math.max(0, index - 1))}
                                        >
                                            {text.previous}
                                        </Button>
                                        <Button
                                            type="button"
                                            variant="primary"
                                            disabled={completionQuestionIndex >= questionsToComplete.length - 1}
                                            onClick={() => setCompletionQuestionIndex((index) => Math.min(questionsToComplete.length - 1, index + 1))}
                                        >
                                            {text.next}
                                        </Button>
                                    </div>
                                    <div className="complete-answers-footer-actions">
                                        {!showCompleteCloseConfirm ? (
                                            <>
                                                <Button type="submit" variant="success" disabled={questionsToComplete.length === 0}>
                                                    {text.saveAnswers}
                                                </Button>
                                                <Button type="button" variant="outline-danger" onClick={handleRequestCloseCompleteAnswers}>{text.close}</Button>
                                            </>
                                        ) : (
                                            <>
                                                <Button type="submit" variant="primary" disabled={questionsToComplete.length === 0}>
                                                    {text.saveAndClose}
                                                </Button>
                                                <Button type="button" variant="outline-danger" onClick={handleCloseCompleteAnswers}>{text.closeWithoutSaving}</Button>
                                                <Button type="button" variant="outline-secondary" onClick={() => setShowCompleteCloseConfirm(false)}>{text.keepEditing}</Button>
                                            </>
                                        )}
                                    </div>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                        )}
                        {selectedPassage && (
                            <Modal className="modal-theme-bg" show={!!selectedPassage} onHide={() => setSelectedPassage(null)} centered scrollable>
                                <Modal.Header closeButton>
                                    <Modal.Title as="h5">{text.passageTitle(selectedPassage.passageNumber)}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p className="mb-0">{selectedPassage.passageText}</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button type="button" variant="soft-danger" onClick={() => setSelectedPassage(null)}>{text.close}</Button>
                                </Modal.Footer>
                            </Modal>
                        )}
                        {/* <!-- Edit Subject Modal --> */}
                        {showModalEdit && ( <Modal className="modal-theme-bg" show={showModalEdit} onHide={handleCloseEdit} centered>
                            <Form onSubmit={(e)=>handleConfirmEdit(e)}>
                              <Modal.Header closeButton>
                                  <Modal.Title as="h5">{text.editSubject}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                  <div className="mb-3">
                                    <Form.Group className="form-group"> 
                                        <Form.Label htmlFor="subjectNameEdit">{text.subjectName}</Form.Label>
                                        <Form.Control type="text" id="subjectNameEdit" value={subjectName} onChange={(e) => setSubjectName(e.target.value)} aria-describedby={text.subjectName} required/>
                                    </Form.Group >
                                  </div>
                              </Modal.Body>
                              <Modal.Footer>
                                  <Button type="submit" variant="success">{text.edit}</Button>
                                  <Button variant="soft-danger" onClick={handleCloseEdit}>{text.close}</Button>
                              </Modal.Footer>
                            </Form>
                        </Modal>
                        )}
                        {/* <!-- Del Modal --> */}
                        {showModalDel && ( <Modal className="modal-theme-bg" show={showModalDel} onHide={handleCloseDel} centered>
                              <Modal.Header closeButton>
                                  <Modal.Title as="h5">{text.confirmDeletion}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                  <div className="mb-3">
                                    <p>{text.deleteSubjectConfirm(selectedSubject?.name)}</p>
                                  </div>
                              </Modal.Body>
                              <Modal.Footer>
                                  <Button type="submit" variant="success" onClick={handleConfirmDelete}>{text.yesDelete}</Button>
                                  <Button variant="soft-danger" onClick={handleCloseDel}>{text.abort}</Button>
                              </Modal.Footer>
                        </Modal>
                        )}{/*
                        <Col>
                            <Card className=" mb-4 rounded-3 ">
                                <Card.Body>
                                    <Card.Title as="h1" className=" pricing-card-title">Name Subject</Card.Title>
                                    <h4 className="my-0 fw-normal mt-3">180 Questions</h4>
                                    <ul className="list-unstyled my-3 p-0">
                                        <li><p>Open Questions: 50</p></li>
                                        <li><p>Closed Questions: 130</p></li>
                                        <li><p>....</p></li>
                                    </ul>
                                    <div className="d-flex justify-content-end">
                                    <button type="button" className="btn btn-soft-success btn-subjet me-2">{quiz}</button>   
                                        <button type="button" className="btn btn-soft-gray btn-subjet me-2">{quest}</button> 
                                        <button type="button" className="btn btn-soft-warning btn-subjet me-2">{edit}</button>    
                                        <button type="button" className="btn btn-soft-danger btn-subjet">{del}</button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        
                        <Col>
                            <Card className=" mb-4 rounded-3 ">
                                <Card.Body>
                                    <Card.Title as="h1" className=" pricing-card-title">Name Subject</Card.Title>
                                    <h4 className="my-0 fw-normal mt-3">....</h4>
                                    <ul className="list-unstyled my-3 p-0">
                                        <li><p>.....</p></li>
                                        <li><p>.....</p></li>
                                        <li><p>.....</p></li>
                                    </ul>
                                    <button type="button" className="btn btn-primary">....</button>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className=" mb-4 rounded-3 ">
                            <Card.Body>
                                    <Card.Title as="h1" className=" pricing-card-title">Name Subject</Card.Title>
                                    <h4 className="my-0 fw-normal mt-3">....</h4>
                                    <ul className="list-unstyled my-3 p-0">
                                        <li><p>.....</p></li>
                                        <li><p>.....</p></li>
                                        <li><p>.....</p></li>
                                    </ul>
                                    <button type="button" className="btn btn-primary">....</button>
                                </Card.Body>
                            </Card>
                        </Col>*/}
                    </Row>
                    {/*}
                    <Row className=" row-cols-1">
                        <Col sm="12">
                            <Card>
                                <Card.Header className=" pb-3">
                                    <h3 className="block-title">Statistiche</h3>
                                </Card.Header>
                                <Card.Body className=" p-0">
                                    <div className="table-responsive pricing pt-2">
                                        <Table id="my-table" className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th className="text-center prc-wrap"></th>
                                                    <th className="text-center prc-wrap">
                                                        <div className={`prc-box ${pricing === 'Basic' ? 'active' : ''} `} onClick={() =>setPricing('Basic')}>
                                                            <div className="h3 pt-4">Completed</div> 
                                                            <span className="type">....</span>
                                                        </div>
                                                    </th>
                                                    <th className="text-center prc-wrap">
                                                        <div className={`prc-box  ${pricing === 'pricing' ? 'active' : ''}`} onClick={() =>setPricing('pricing')}>
                                                            <div className="h3 pt-4">Info 2</div>
                                                            <span className="type">....</span>
                                                        </div>
                                                    </th>
                                                    <th className="text-center prc-wrap">
                                                        <div className={`prc-box ${pricing === 'Platinum' ? 'active' : ''}`} onClick={() =>setPricing('Platinum')}>
                                                            <div className="h3 pt-4">Info 3</div>
                                                            <span className="type">....</span>
                                                        </div>
                                                    </th>
                                                    <th className="text-center prc-wrap">
                                                        <div className={`prc-box ${pricing === 'Premium' ? 'active' : ''} `} onClick={() =>setPricing('Premium')} >
                                                            <div className="h3 pt-4">Info 4</div>
                                                            <span className="type">....</span>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                        <tbody>
                                            {pricingLists.map((item) => (
                                                <tr key={item.title}>
                                                    <th className="text-center" scope="row">{item.title}</th>
                                                    <td className={`text-center child-cell ${pricing === 'Basic' ? 'active' : ''}`}>{item.icon}</td>
                                                    <td className={`text-center child-cell ${pricing === 'pricing' ? 'active' : ''}`}>{item.icon1}</td>
                                                    <td className={`text-center child-cell ${pricing === 'Platinum' ? 'active' : ''}`}>{item.icon2}</td>
                                                    <td className={`text-center child-cell ${pricing === 'Premium' ? 'active' : ''}`}>{item.icon3}</td>
                                                </tr>
                                                ))}
                                                <tr>
                                                    <td className="text-center"><i className="ri-close-line i_close"></i></td>
                                                    <td className="text-center"> <Button href="#" variant="outline-primary">....</Button></td>
                                                    <td className="text-center"> <Button href="#" variant="outline-primary">....</Button></td>
                                                    <td className="text-center"> <Button href="#" variant="outline-primary">....</Button></td>
                                                    <td className="text-center"> <Button href="#" variant="outline-primary">....</Button></td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Card.Header className=" pb-3">
                                    <h3 className="block-title">Payments</h3>
                                </Card.Header>
                                <Card.Body className=" p-0">
                                    <div className="table-responsive pricing pt-2">
                                        <Table className="table table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>
                                                        <div>
                                                            <div className="text-bold h5">Free</div>
                                                            <div className="d-flex justify-content-start align-items-center mt-4">
                                                                <small>USD</small>
                                                                <div className="mx-2 h4">$0</div>
                                                                <small> / mo</small>
                                                            </div>
                                                            <div className="mt-3">
                                                                <div className="d-flex">billed yearly</div>
                                                                <div className="d-flex align-items-center">
                                                                    <small className="bold me-2">$0.00</small> billed monthly
                                                                </div>
                                                            </div>
                                                            <button className="btn btn-primary rounded-pill mt-3 w-100">Free</button>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div>
                                                            <div className="d-flex align-items-center">
                                                                <div className="text-bold h5">Pro</div>
                                                                <span className="badge rounded-pill bg-soft-success ms-2">Popular</span>
                                                            </div>
                                                            <div className="d-flex justify-content-start align-items-center mt-4">
                                                                <small>USD</small>
                                                                <div className="mx-2 h4">$15</div>
                                                                <small> / mo</small>
                                                            </div>
                                                            <div className="mt-3">
                                                                <div className="d-flex">billed yearly</div>
                                                                <div className="d-flex align-items-center">
                                                                    <small className="bold me-2">$169.99</small> billed monthly
                                                                </div>
                                                            </div>
                                                            <button className="btn btn-primary rounded-pill mt-3 w-100">Buy Pro</button>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div>
                                                            <div className="text-bold h5">Enterprise</div>
                                                            <div className="d-flex justify-content-start align-items-center mt-4">
                                                                <small>USD</small>
                                                                <div className="mx-2 h4">$29</div>
                                                                <small> / mo</small>
                                                            </div>
                                                            <div className="mt-3">
                                                                <div className="d-flex">billed yearly</div>
                                                                <div className="d-flex align-items-center">
                                                                    <small className="bold me-2">$319.89</small> billed monthly
                                                                </div>
                                                            </div>
                                                            <button className="btn btn-primary rounded-pill mt-3 w-100">Buy Enterprise</button>
                                                        </div>
                                                    </th>
                                                    <th>
                                                        <div>
                                                            <div className="text-bold h5">Premium</div>
                                                            <div className="d-flex justify-content-start align-items-center mt-4">
                                                                <small>USD</small>
                                                                <div className="mx-2 h4">$49</div>
                                                                <small> / mo</small>
                                                            </div>
                                                            <div className="mt-3">
                                                                <div className="d-flex">billed yearly</div>
                                                                <div className="d-flex align-items-center">
                                                                    <small className="bold me-2">$549.09</small> billed monthly
                                                                </div>
                                                            </div>
                                                            <button className="btn btn-primary rounded-pill mt-3 w-100">Buy Premium</button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th colSpan="5" className="bg-light">Features</th>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Features 1</th>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center active">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Features 2</th>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center active">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Features 3</th>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center active">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Features 4</th>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center active">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th colSpan="5" className="bg-light">Payment</th>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Payment 1</th>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center active">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Payment 2</th>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center active">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Payment 3</th>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor" stroke="currentColor"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center active">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Payment 4</th>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center active">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                    <td className="text-center">
                                                        <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M23 7L6.44526 17.8042C5.85082 18.1921 5.0648 17.9848 4.72059 17.3493L1 10.4798" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                                        </svg>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card>
                                <Row className=" no-gutters">
                                    <Col md="8">
                                        <Card.Body>
                                        <h4>Lifetime Membership</h4>
                                        <p className="mt-2">
                                            If you will take advantage of the above-listed amenities, classes, and services, Life Time's membership fees may be worth the cost.
                                        </p>
                                        <div className="mb-5 pt-2">
                                            <p className="line-around text-gray mb-0"><span className="line-around-1">Included Features</span></p>
                                        </div>
                                        <Row>
                                            <Col lg="6" md="6" sm="12" className="">
                                                <div className="d-flex align-items-center">
                                                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                        <path d="M8.43994 12.0002L10.8139 14.3732L15.5599 9.6272" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                    </svg>
                                                    <div className="ms-2">Private forum access</div>
                                                </div>                           
                                            </Col>
                                            <Col lg="6" md="6" sm="12" className="">
                                                <div className="d-flex align-items-center">
                                                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                        <path d="M8.43994 12.0002L10.8139 14.3732L15.5599 9.6272" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                    </svg>
                                                    <div className="ms-2">Private forum access</div>
                                                </div>                           
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg="6" md="6" sm="12" className="">
                                                <div className="d-flex align-items-center">
                                                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                        <path d="M8.43994 12.0002L10.8139 14.3732L15.5599 9.6272" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                    </svg>
                                                    <div className="ms-2">Private forum access</div>
                                                </div>                           
                                            </Col>
                                            <Col lg="6" md-="6" sm="12">
                                                <div className="d-flex align-items-center">
                                                    <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                        <path d="M8.43994 12.0002L10.8139 14.3732L15.5599 9.6272" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                    </svg>
                                                    <div className="ms-2">Private forum access</div>
                                                </div>                           
                                            </Col>
                                        </Row>
                                        </Card.Body>
                                    </Col>
                                    <Col md="4">
                                        <Card.Body className=" text-center h-100 iq-single-card">
                                            <div className="d-flex align-items-center justify-content-center mb-2">
                                                <Card.Title as="h1" className=" pricing-card-title mb-0">
                                                    $599                              
                                                </Card.Title>
                                                <small className="ms-1 text-muted fw-light">USD</small>
                                            </div>
                                            <div className="font-medium text-center text-gray">
                                                <div>No monthly subscription,</div>
                                                <div>you only pay once.</div>
                                            </div>
                                            <button className="btn btn-primary rounded-pill mt-5 w-100">Get Started</button>
                                        </Card.Body>
                                    </Col>
                                </Row>                  
                            </Card>               
                        </Col>
                    </Row>
                    {*/}
                    {/*}
                    <Row className=" iq-star-inserted row-cols-1 row-cols-md-2 row-cols-lg-3 mb-5 mt-5 text-center">
                        <Col className=" iq-star-inserted-1">
                            <Card className=" my-5">
                                <Card.Body>
                                    <h2 className="my-0 fw-normal mb-4">Enterprise</h2>
                                    <Card.Title as="h1" className=" pricing-card-title mb-0">$29 <small className="text-gray"> / month</small></Card.Title>
                                    <p className="mb-0">billed yearly</p>
                                    <p>$79.9 billed monthly</p>
                                    <ul className="list-unstyled my-3 p-0">
                                        <li><p>30 users included</p></li>
                                        <li><p>15 GB of storage</p></li>
                                        <li><p>Call and email support</p></li>
                                        <li><p>Help center access</p></li>
                                    </ul>
                                    <button type="button" className="btn btn-primary rounded-pill w-100">Get Started</button>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col className=" iq-star-inserted-2">
                            <Card className=" mb-0 shadow-lg">
                                <Card.Body>
                                    <h2><span className="badge rounded-pill bg-soft-primary mb-4"><small className="text-uppercase px-3">Popular</small></span></h2>
                                    <h2 className="my-0 fw-normal mb-4">Pro</h2>
                                    <Card.Title as="h1" className=" pricing-card-title mb-0">$15<small className="text-gray"> / month</small></Card.Title>
                                    <p className="mb-0">billed yearly</p>
                                    <p>$55.0 billed monthly</p>
                                    <ul className="list-unstyled my-3 p-0">
                                        <li><p>20 users included</p></li>
                                        <li><p>10 GB of storage</p></li>
                                        <li><p>Priority email support</p></li>
                                        <li><p>Help center access</p></li>
                                    </ul>
                                    <button type="button" className="btn btn-primary rounded-pill w-100">Get Started</button>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col className=" iq-star-inserted-3">
                            <Card className=" my-5">
                                <Card.Body>
                                    <h2 className="my-0 fw-normal mb-4">Premium</h2>
                                    <Card.Title as="h1" className=" pricing-card-title mb-0">$49 <small className="text-gray"> / month</small></Card.Title>
                                    <p className="mb-0">billed yearly</p>
                                    <p>$99.9 billed monthly</p>
                                    <ul className="list-unstyled my-3 p-0">
                                        <li><p>50 users included</p></li>
                                        <li><p>60 GB of storage</p></li>
                                        <li><p>24 X 7 call support</p></li>
                                        <li><p>Help center access</p></li>
                                    </ul>
                                    <button type="button" className="btn btn-primary rounded-pill w-100">Get Started</button>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {*/}
                </Col>
            </Row>
        </div>
    )
}

export default Subjects
